{
  "addons.addonList": "Листа додатака",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Креирајте и преузмите свој АПИ кључ са ове везе",
  "addons.ambientWeatherDescription": "Ambient метеостанице (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "АПИ кључ",
  "addons.applicationKey": "Кључ апликације",
  "addons.connect": "Повежи",
  "addons.davisApiSecret": "API тајни",
  "addons.davisApiV2Key": "V2 API кључ",
  "addons.davisDescription": "Davis метеостанице (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Прибавите ваш V2 API кључ са овог линка",
  "addons.disconnect": "Прекини везу",
  "addons.ecowittCreateAndRetrieveKeys": "Направите и преузмите свој АПИ кључ и кључ апликације са ове везе",
  "addons.ecowittDescription": "Ecowitt нуди професионалне метеоролошке станице, бежичне унутрашње/спољашње термометре, прецизне кишомере, сензоре квалитета ваздуха и још много тога.",
  "addons.helpLink": "Како повезати {provider}",
  "addons.myAcuriteAccountOnHold": "Ваш налог је стављен на чекање. Унесите лозинку да бисте поново повезали свој налог",
  "addons.myAcuriteDescription": "AcuRite је бренд метеоролошке станице број 1 у Северној Америци. Као лидер у технологији времена, температуре и временских прилика, AcuRite вам пружа детаљне информације о вашем унутрашњем и спољашњем окружењу тако да можете са поверењем да планирате свој дан.",
  "addons.myAcuriteEnterCredentials": "Унесите своје My AcuRite акредитиве да бисте повезали свој My AcuRite налог са SmartMixin-ом",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Да промените температуру у кући, било из кревете било са друге стране света, користите ваш Netatmo Термостат.",
  "addons.netatmoThermostat": "Netatmo Термостат",
  "addons.netatmoWeather": "Netatmo Метеостаница",
  "addons.netatmoWeatherDescription": "Ваша лична метеоролошка станица",
  "addons.or": "или",
  "addons.providerAccountDisconnected": "Веза са вашом метеоролошком службом је истекла. Поново се повежите да бисте наставили ажурирање података.",
  "addons.reconnect": "Повежи поново",
  "addons.weatherflowCreateToken": "Направи и повуци токен са овог линка",
  "addons.weatherflowTempestDescription": "Tempest метеосистем са уграђеним сензором ветра, сензором кише",
  "addons.wundergroundApiKey": "АПИ кључ",
  "addons.wundergroundDescription": "Weather Underground је глобална заједница људи која повезује податке са сензора животне средине као што су метеоролошке станице и монитори квалитета ваздуха како бисмо могли да испоручимо богате, хиперлокалне податке који су вам потребни за подстицање ваших страсти.",
  "addons.wundergroundRetrieveApiKey": "Преузмите свој АПИ кључ са ове везе",
  "addons.wundergroundStationId": "ИД станице",
  "airQuality.adviceActivityGood": "Идеалан дан за кретање на отвореном",
  "airQuality.adviceActivityHazardous": "Избегавајте сваку физичку активност на отвореном",
  "airQuality.adviceActivityLabel": "Физичка активност",
  "airQuality.adviceActivityModerate": "Добар дан за кретање на отвореном",
  "airQuality.adviceActivitySensitive": "Размислите о краћим и мање интензивним активностима на отвореном",
  "airQuality.adviceActivityUnhealthy": "Смањите дуге или интензивне активности и правите више пауза",
  "airQuality.adviceActivityVeryUnhealthy": "Избегавајте дуге или интензивне активности; размислите о премештању у затворени простор",
  "airQuality.adviceGroupsGood": "Нису потребне посебне мере опреза",
  "airQuality.adviceGroupsHazardous": "Останите у затвореном простору и смањите активност",
  "airQuality.adviceGroupsLabel": "Осетљиве групе",
  "airQuality.adviceGroupsModerate": "Посебно осетљиве особе: краће и мање интензивне активности",
  "airQuality.adviceGroupsSensitive": "Краће и мање интензивне активности на отвореном, уз више пауза",
  "airQuality.adviceGroupsUnhealthy": "Избегавајте дуге или интензивне активности на отвореном; размислите о премештању у затворени простор",
  "airQuality.adviceGroupsVeryUnhealthy": "Избегавајте сваку физичку активност на отвореном; одложите је или преместите у затворени простор",
  "airQuality.adviceTimingLabel": "Када изаћи напоље",
  "airQuality.adviceTimingMorning": "Најбоље ујутру — тада је ниво озона нижи",
  "airQuality.airQuality": "Квалитет ваздуха",
  "airQuality.airQualityIndex": "Индекс квалитета ваздуха",
  "airQuality.aqiForecast": "Прогноза квалитета ваздуха",
  "airQuality.co": "Угљен моноксид",
  "airQuality.dailyForecast": "Дневна прогноза",
  "airQuality.details": "Детаљи",
  "airQuality.dominantPollutant": "Доминантни загађивач",
  "airQuality.expectedPeak": "Очекивани врхунац",
  "airQuality.good": "Добро",
  "airQuality.goodDescription": "Квалитет ваздуха је задовољавајући и загађеност ваздуха представља малу опасност.",
  "airQuality.hazardous": "Опасно",
  "airQuality.hazardousDescription": "Здравствено упозорење: све особе су под ризиком озбиљних здравствених симптома.",
  "airQuality.indoorAirQuality": "Квалитет ваздуха у затвореном простору",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Умерено",
  "airQuality.moderateDescription": "Квалитет ваздуха је прихватљив; ипак мањем броју људи који су изразито осетљиви на загађење ваздуха, поједини полутанти могу изазвати тегобе",
  "airQuality.no2": "Азот диоксид",
  "airQuality.noForecastForLocation": "За ову локацију није доступна прогноза квалитета ваздуха.",
  "airQuality.now": "Сада",
  "airQuality.o3": "Озон",
  "airQuality.pm10": "Честице пречника 10 μm или мање",
  "airQuality.pm25": "Честице пречника 2.5 μm или мање",
  "airQuality.pollutants": "Загађујуће материје",
  "airQuality.ppb": "ppb",
  "airQuality.recommendations": "Препоруке",
  "airQuality.sensitiveUnhealthy": "Осетљиве особе су угрожене",
  "airQuality.sensitiveUnhealthyDescription": "Јако осетљиве особе могу осетити тегобе. Просечна здрава особа неће имати проблем.",
  "airQuality.so2": "Сумпор диоксид",
  "airQuality.subIndex": "AQI подиндекс",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Разумевање индекса",
  "airQuality.unhealthy": "Нездраво",
  "airQuality.unhealthyDescription": "Сви ће да осете тегобе. Јако осетљиве особе могу да имају израженије симптоме.",
  "airQuality.veryUnhealthy": "Веома нездраво",
  "airQuality.veryUnhealthyDezscription": "Упозорење на повећани ризик. Све особе ће вероватно осетити симптоме.",
  "alerts.addAlert": "Додај обавештење",
  "alerts.addCondition": "Додај услов",
  "alerts.alertAdded": "Обавештење успешно додато",
  "alerts.alertAuthorizationNotice": "Обавештења ће да раде само ако овластите Smartmixin да приказује обавештења",
  "alerts.alertDeleted": "Обавештење успешно обрисано",
  "alerts.alertEdited": "Обавештење успешно измењено",
  "alerts.alertName": "Назив обавештења",
  "alerts.alertWhen": "Желим да будем обавештен кад:",
  "alerts.aqiGreaterThan": "AQI већи од",
  "alerts.aqiGreaterThanThreshold": "AQI већи од {value}{unit}",
  "alerts.aqiLessThan": "AQI мањи од",
  "alerts.aqiLessThanThreshold": "AQI мањи од {value}{unit}",
  "alerts.atLeastOneCondition": "Морате додати барем један услов",
  "alerts.co2GreaterThan": "Концентрација CO2 већа од",
  "alerts.co2GreaterThanThreshold": "Концентрација CO2 већа од {value}{unit}",
  "alerts.co2LessThan": "Концентрација CO2 мања од",
  "alerts.co2LessThanThreshold": "Концентрација CO2 мања од {value}{unit}",
  "alerts.conditions": "Услови",
  "alerts.createAlert": "Направи обавештење",
  "alerts.dailyPrecipitationGreaterThan": "Дневне падавине веће од",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Дневне падавине изнад прага од {value}{unit}",
  "alerts.deleteAlert": "Обриши обавештење",
  "alerts.editAlert": "Уреди обавештење",
  "alerts.editCondition": "Уреди услове",
  "alerts.gustSpeedGreaterThan": "Удари ветра јачи од",
  "alerts.gustSpeedGreaterThanThreshold": "Удари ветра су јачи од {value}{unit}",
  "alerts.gustSpeedLessThan": "Удари ветра су мањи од",
  "alerts.gustSpeedLessThanThreshold": "Удари ветра су мањи од {value}{unit}",
  "alerts.heatIndexGreaterThan": "Индекс топлоте већи од",
  "alerts.heatIndexGreaterThanThreshold": "Индекс топлоте већи од {value}{unit}",
  "alerts.heatIndexLessThan": "Индекс топлоте мањи од",
  "alerts.heatIndexLessThanThreshold": "Индекс топлоте мањи од {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex већи од",
  "alerts.humidexGreaterThanThreshold": "Humidex већи од {value}{unit}",
  "alerts.humidexLessThan": "Humidex мањи од",
  "alerts.humidexLessThanThreshold": "Humidex мањи од {value}{unit}",
  "alerts.humidityGreaterThan": "Влажност ваздуха је већа од",
  "alerts.humidityGreaterThanThreshold": "Влажност ваздуха је већа од {value}{unit}",
  "alerts.humidityLessThan": "Влажност ваздуха је мања од",
  "alerts.humidityLessThanThreshold": "Влажност ваздуха је мања од {value}{unit}",
  "alerts.inProgress": "У току",
  "alerts.myAlerts": "Моја обавештења",
  "alerts.noConfiguredAlert": "Нисте до сада направили нити једно обавештење, почните тако што ћете га направити",
  "alerts.noiseGreaterThan": "Бука је јача од",
  "alerts.noiseGreaterThanThreshold": "Бука је јача од {value}{unit}",
  "alerts.noiseLessThan": "Бука је тиша од",
  "alerts.noiseLessThanThreshold": "Бука је тиша од {value}{unit}",
  "alerts.noteOnConditions": "Имајте на уму да је ово обавештење активирано када се испуне сви услови испод",
  "alerts.noTriggerHistory": "Ово упозорење још није активирано.",
  "alerts.pm10GreaterThan": "PM 10 веће од",
  "alerts.pm10GreaterThanThreshold": "PM 10 веће од {value}{unit}",
  "alerts.pm10LessThan": "PM 10 мање од",
  "alerts.pm10LessThanThreshold": "PM 10 мање од {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 веће од",
  "alerts.pm1GreaterThanThreshold": "PM 1 веће од {value}{unit}",
  "alerts.pm1LessThan": "PM 1 мање од",
  "alerts.pm1LessThanThreshold": "PM 1 мање од {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 веће од",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 веће од {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 мање од",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 мање од {value}{unit}",
  "alerts.postStormSummary": "Резиме након падавина",
  "alerts.postStormSynopsisHelper": "Добићете обавештење са резимеом након сваке кише.",
  "alerts.postStormSynopsisSoleCondition": "Резиме након олује не може се комбиновати са другим условима.",
  "alerts.precipitationGreaterThan": "Часовне падавине веће од",
  "alerts.precipitationGreaterThanThreshold": "Часовне падавине изнад прага од {value}{unit}",
  "alerts.pressureGreaterThan": "Ваздушни притисак изнад",
  "alerts.pressureGreaterThanThreshold": "Ваздушни притисак изнад {value}{unit}",
  "alerts.pressureLessThan": "Ваздушни притисак испод",
  "alerts.pressureLessThanThreshold": "Ваздушни притисак нижи од {value}{unit}",
  "alerts.rainRateGreaterThan": "Интензитет кише већи од",
  "alerts.rainRateGreaterThanThreshold": "Интензитет кише изнад прага од {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Осунчаност већа од",
  "alerts.solarRadiationGreaterThanThreshold": "Осунчаност већа од {value}{unit}",
  "alerts.solarRadiationLessThan": "Осунчаност мања од",
  "alerts.solarRadiationLessThanThreshold": "Осунчаност мања од {value}{unit}",
  "alerts.stormChartUnavailable": "Историја кише за ове падавине није доступна.",
  "alerts.stormDetail": "Резиме падавина",
  "alerts.stormDuration": "Трајање",
  "alerts.stormEnd": "Крај",
  "alerts.stormPeakRate": "Највећи интензитет кише",
  "alerts.stormStart": "Почетак",
  "alerts.stormTotal": "Укупне падавине",
  "alerts.temperatureGreaterThan": "Температура виша од",
  "alerts.temperatureGreaterThanThreshold": "Температура виша од {value}{unit}",
  "alerts.temperatureLessThan": "Температура нижа од",
  "alerts.temperatureLessThanThreshold": "Температура нижа од {value}{unit}",
  "alerts.thswGreaterThan": "THSW већи од",
  "alerts.thswGreaterThanThreshold": "THSW већи од {value}{unit}",
  "alerts.thswLessThan": "THSW мањи од",
  "alerts.thswLessThanThreshold": "THSW мањи од {value}{unit}",
  "alerts.thwGreaterThan": "THW већи од",
  "alerts.thwGreaterThanThreshold": "THW већи од {value}{unit}",
  "alerts.thwLessThan": "THW мањи од",
  "alerts.thwLessThanThreshold": "THW мањи од {value}{unit}",
  "alerts.triggerHistory": "Историја упозорења",
  "alerts.uvGreaterThan": "UV индекс већи од",
  "alerts.uvGreaterThanThreshold": "UV индекс већи од {value}{unit}",
  "alerts.uvLessThan": "UV индекс мањи од",
  "alerts.uvLessThanThreshold": "UV индекс мањи {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видљивост већа од {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видљивост мања од {value}{unit}",
  "alerts.visiblityGreaterThan": "Видљивост већа од",
  "alerts.visiblityLessThan": "Видљивост мања од",
  "alerts.whichMeasure": "За која мерења желите да примате обавештења?",
  "alerts.whichModule": "За који модул бисте желели да будете упозорени?",
  "alerts.windChillGreaterThan": "Осећај хладноће већи од",
  "alerts.windChillGreaterThanThreshold": "Осећај хладноће већи од {value}{unit}",
  "alerts.windChillLessThan": "Осећај хладноће мањи од",
  "alerts.windChillLessThanThreshold": "Осећај хладноће мањи од {value}{unit}",
  "alerts.windSpeedGreaterThan": "Брзина ветра већа од",
  "alerts.windSpeedGreaterThanThreshold": "Брзина ветра већа од {value}{unit}",
  "alerts.windSpeedLessThan": "Брзина ветра мања од",
  "alerts.windSpeedLessThanThreshold": "Брзина ветра мања од {value}{unit}",
  "astral.aboveHorizonAllDay": "Цео дан изнад хоризонта",
  "astral.aboveTheHorizon": "изнад хоризонта",
  "astral.apparentSize": "Привидни пречник",
  "astral.apparentSizeAcross": "{size} у пречнику",
  "astral.astronomicalDawn": "Астрономска зора",
  "astral.astronomicalDusk": "Астрономски сумрак",
  "astral.astronomicalSunPhase": "Астрономски {sunPhase}",
  "astral.belowHorizonAllDay": "Цео дан испод хоризонта",
  "astral.belowHorizonSince": "Испод хоризонта од {time}",
  "astral.belowHorizonSinceOn": "Испод хоризонта од {day} {time}",
  "astral.brightAllNight": "Светло целе ноћи — никад потпуно мрачно",
  "astral.brightestMoment": "Најсветлији тренутак",
  "astral.civilDawn": "Грађанска зора",
  "astral.civilDusk": "Грађански сумрак",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.darkSkyBetween": "Тамно небо {from} → {to}",
  "astral.darkSkyWindow": "Тамно небо {from} → {to} · {duration} без Месеца",
  "astral.dawn": "Свитање",
  "astral.dayLength": "Дужина дана",
  "astral.daylightThroughTheYear": "Дужина дана током године",
  "astral.dayOfCycle": "дан {day} од {total}",
  "astral.doesNotOccurToday": "Данас се не дешава",
  "astral.domeHint": "Превуците за кретање кроз ноћ",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.dusk": "Сумрак",
  "astral.earliestSunrise": "Најранији излазак сунца",
  "astral.earliestSunset": "Најранији залазак сунца",
  "astral.equinox": "Равнодневница",
  "astral.equinoxIn": "Равнодневница за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.evening": "Вече",
  "astral.exactPhaseAt": "Тачно у {time}",
  "astral.firstQuarter": "Прва четврт",
  "astral.firstSunriseIn": "Први излазак сунца за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.firstSunsetIn": "Први залазак сунца за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.fullMoon": "Пун месец",
  "astral.goldenHourBegins": "Почетак златног сата",
  "astral.goldenHourEnds": "Крај златног сата",
  "astral.highestPoint": "Највиша тачка",
  "astral.inDays": "за {days, plural, one {# дан} few {# дана} other {# дана}}",
  "astral.lastQuarter": "Последња четврт",
  "astral.latestSunrise": "Најкаснији излазак сунца",
  "astral.latestSunset": "Најкаснији залазак сунца",
  "astral.litShort": "Осветљ.",
  "astral.longestDay": "Најдужи дан",
  "astral.lowestPoint": "Најнижа тачка",
  "astral.maxAltitudeShort": "Макс.",
  "astral.midday": "Подне",
  "astral.midnightSun": "Поноћно сунце",
  "astral.midnightSunPeriod": "Поноћно сунце",
  "astral.milestoneFootnotePolar": "Овде сунце {days, plural, one {# дан} few {# дана} other {# дана}} у години нити излази нити залази, па списак уместо уобичајених крајности изласка и заласка показује када се то дешава.",
  "astral.milestoneFootnoteTemperate": "Најранији залазак и најкаснији излазак не падају на најкраћи дан — та два датума одређује једначина времена, а не солстициј.",
  "astral.moon": "Месец",
  "astral.moonAltitude": "Висина",
  "astral.moonDirection": "Азимут",
  "astral.moonDistance": "Удаљеност",
  "astral.moonlessFor": "{duration} без Месеца",
  "astral.moonPhases": "Месечеве фазе",
  "astral.moonrise": "Излазак месеца",
  "astral.moonset": "Залазак месеца",
  "astral.moonUpAllNight": "Месец је изнад хоризонта целе ноћи",
  "astral.moonWashesOutNight": "Месец је изнад хоризонта од {rise} до {set} и осветљава целу ноћ",
  "astral.morning": "Јутро",
  "astral.nauticalDawn": "Наутичка зора",
  "astral.nauticalDusk": "Наутички сумрак",
  "astral.nauticalSunPhase": "Наутички {sunPhase}",
  "astral.newMoon": "Млад месец",
  "astral.nextDay": "+1 дан",
  "astral.nextProperlyDarkNight": "Следећа заиста тамна ноћ",
  "astral.nextRise": "следећи излазак у {time}",
  "astral.nextRiseOn": "следећи излазак {day} у {time}",
  "astral.nextSevenNights": "Следећих седам ноћи",
  "astral.noAstronomicalDarknessTonight": "Ноћас нема астрономске таме",
  "astral.noDarkNightAhead": "Нема је у наредне две недеље",
  "astral.noon": "Подне",
  "astral.noSunriseToday": "Данас нема изласка сунца",
  "astral.nowAtBearing": "сада {altitude} · азимут {direction}",
  "astral.observing": "Посматрање",
  "astral.ofDaylightLeft": "дневног светла преостало",
  "astral.overTheNextThreeWeeks": "током наредне 3 недеље",
  "astral.percentLit": "{percent} осветљено",
  "astral.polarNight": "Поларна ноћ",
  "astral.polarNightPeriod": "Поларна ноћ",
  "astral.remainingDaylight": "Преостала обданица",
  "astral.rightNow": "Управо сада",
  "astral.riseShort": "Излазак",
  "astral.setShort": "Залазак",
  "astral.shortestDay": "Најкраћи дан",
  "astral.solarNoon": "Право подне",
  "astral.solstice": "Солстициј",
  "astral.sunBelowHorizon": "Сунце {degrees}° испод хоризонта",
  "astral.sunEvents": "Сунчеви догађаји",
  "astral.sunNeverDarkEnough": "Сунце никад не пада 18° испод хоризонта",
  "astral.sunNeverSets": "Сунце не залази",
  "astral.sunrise": "Излазак сунца",
  "astral.sunriseAndSunset": "Излазак и залазак сунца",
  "astral.sunriseAt": "Излазак сунца у {time}",
  "astral.sunset": "Залазак сунца",
  "astral.sunsetAt": "Залазак сунца у {time}",
  "astral.thisYearAtNorth": "Ове године на {degrees}° северне ширине",
  "astral.thisYearAtSouth": "Ове године на {degrees}° јужне ширине",
  "astral.tonight": "Ноћас",
  "astral.totalDaylight": "Укупна обданица",
  "astral.twilightAllNight": "Сумрак целе ноћи — никад потпуно мрачно",
  "astral.upFor": "{duration} изнад хоризонта",
  "astral.usableLight": "Искористива светлост",
  "astral.vsAverage": "{percent} од просека",
  "astral.vsYesterday": "у односу на јуче",
  "astral.waningCrescent": "Опадајући срп",
  "astral.waningGibbous": "Опадајући месец",
  "astral.waxingCrescent": "Растући срп",
  "astral.waxingGibbous": "Растући месец",
  "astral.whereToLook": "Где гледати",
  "astral.withoutTheMoon": "{duration} без Месеца",
  "auth.alreadyHaveAccount": "Већ имате налог?",
  "auth.authContainerTagline": "Ваша лична временска табла. Повежите своје станице и добијте податке у реалном времену надохват руке.",
  "auth.backToLogin": "Назад на пријаву",
  "auth.catchPhrase": "Паметна платформа за праћење временских услова",
  "auth.checkYourEmail": "Проверите своју е-пошту",
  "auth.continueWithApple": "Наставите са Apple",
  "auth.continueWithFacebook": "Наставите са Facebook",
  "auth.continueWithGoogle": "Наставите са Google",
  "auth.email": "Адреса е-поште",
  "auth.emailRequiredLoginFacebook": "Потребна је потврда путем е-поште",
  "auth.emailVerification": "Е-маил Верификација",
  "auth.emailVerificationFailure": "Десио се проблем са верификацијом путем е-поште.",
  "auth.emailVerificationSuccess": "Ваша адреса е-поште је успешно верификована.",
  "auth.firstName": "Име",
  "auth.forgotPassword": "Заборавили сте лозинку?",
  "auth.forgotPasswordSubtitle": "Унесите своју е-пошту и послаћемо вам линк за ресетовање лозинке.",
  "auth.lastName": "Презиме",
  "auth.login": "Пријава",
  "auth.loginSubtitle": "Добродошли назад! Молимо унесите своје податке.",
  "auth.loginToSmartMixinDescription": "Унесите своје SmartMixin акредитиве да бисте приступили свом налогу.",
  "auth.logout": "Одјава",
  "auth.logoutConfirmation": "Да ли сте сигурни да желите да прекинете везу?",
  "auth.noAccountYet": "Још немате налог?",
  "auth.or": "или",
  "auth.password": "Лозинка",
  "auth.passwordAgain": "Поновите лозинку",
  "auth.passwordReset": "Ресет лозинке",
  "auth.passwordResetSuccess": "Ваша лозинка је успешно промењена.",
  "auth.register": "Креирај налог",
  "auth.registerDescription": "Направите бесплатан SmartMixin налог за повезивање ваших метеоролошких станица, праћење временских података и приступ напредним аналитичким алатима.",
  "auth.registerSubtitle": "Креирајте свој налог да бисте започели.",
  "auth.registerSuccess": "Успешно сте се регистровали! Управо смо вам послали верификациони мејл на {emailAddress} са детаљнијим инструкцијама.",
  "auth.restorePassword": "Поврати лозинку",
  "auth.restorePasswordSuccess": "Управо смо вам послали линк за ресет лозинке на {emailAddress} са детаљнијим инструкцијама.",
  "auth.sendReset": "Пошаљи инструкције за ресет",
  "auth.signInWithApple": "",
  "auth.socialAccount": "или користите ваш налог",
  "auth.staffVerificationCode": "Код за потврду",
  "auth.staffVerificationExpiresIn": "Потврђено. Истиче за {duration}.",
  "auth.staffVerificationInvalidCode": "Нетачан код. Покушајте поново.",
  "auth.staffVerificationLoginAsStopped": "Login As је заустављен: унесите код за потврду на екрану Debug да бисте наставили.",
  "auth.staffVerificationNotEnrolled": "За ваш налог није подешена апликација за аутентификацију. Додајте је у безбедносним подешавањима администрације.",
  "auth.staffVerificationPrompt": "Унесите шестоцифрени код из апликације за аутентификацију или код за опоравак да бисте користили Login As и претрагу корисника.",
  "auth.staffVerificationSetupLink": "Додај апликацију за аутентификацију",
  "auth.staffVerificationSubmit": "Потврди",
  "auth.staffVerificationTitle": "Провера особља",
  "auth.welcome": "Добродошли у SmartMixin",
  "auth.welcomeBack": "Добродошли назад!",
  "calendar.april": "Април",
  "calendar.august": "Август",
  "calendar.dateFormat": "Формат датума",
  "calendar.day": "Дан",
  "calendar.december": "Децембар",
  "calendar.end": "Крај",
  "calendar.february": "Фебруар",
  "calendar.hours": "Часови",
  "calendar.hoursShort": "часова",
  "calendar.january": "Јануар",
  "calendar.july": "Јул",
  "calendar.june": "Јун",
  "calendar.last24Hours": "последња 24 сата",
  "calendar.last30Days": "последњих 30 дана",
  "calendar.last7Days": "последњих 7 дана",
  "calendar.march": "Март",
  "calendar.max": "Максимум",
  "calendar.may": "Мај",
  "calendar.month": "Месец",
  "calendar.months": "месеци",
  "calendar.november": "Новембар",
  "calendar.october": "Октобар",
  "calendar.oneDay": "1-дан",
  "calendar.oneHour": "1-сат",
  "calendar.oneMonth": "1-месец",
  "calendar.oneWeek": "1-недеља",
  "calendar.previous24Hours": "Претходна 24 сата",
  "calendar.previous30Days": "Претходних 30 дана",
  "calendar.previous7Days": "Претходних 7 дана",
  "calendar.previousDay": "Претходни дан",
  "calendar.previousMonth": "Претходни месец",
  "calendar.previousWeek": "Претходну недељу",
  "calendar.previousYear": "Претходну годину",
  "calendar.sameDayLastYear": "На исти дан претходне године",
  "calendar.sameMonthLastYear": "Током истог месеца претходне године",
  "calendar.selectADate": "Изаберите датум",
  "calendar.selectAggregation": "Изаберите приказану вредност",
  "calendar.selectAMonth": "Изаберите месец дана",
  "calendar.selectAYear": "Изаберите годишњу",
  "calendar.selectGranularity": "Изабери прецизност",
  "calendar.selectTimescale": "Изабери временску скалу",
  "calendar.september": "Септембар",
  "calendar.sixHours": "6-сати",
  "calendar.start": "Почетак",
  "calendar.thirtyMinutes": "30-минута",
  "calendar.threeHours": "3-сата",
  "calendar.use24HourFormat": "Користи 24-часовни формат",
  "calendar.week": "Недеља",
  "calendar.year": "Година",
  "calendar.yesterday": "Јучер",
  "common.accountDeleted": "Ваш налог је успешно избрисан.",
  "common.accountOnHold": "Веза вашег налога је истекла. Поново се повежите да бисте наставили ажурирање података.",
  "common.add": "Додај",
  "common.addAStation": "Додај станицу",
  "common.addToFavorites": "Додај у фаворите",
  "common.addYourOwnStation": "Додајте своју станицу",
  "common.afternoon": "Поподне",
  "common.alreadyPremium": "Већ имате премијум налог!",
  "common.alsoAvailableOn": "Доступно и на:",
  "common.altitude": "Надморска висина",
  "common.analysis": "Анализа",
  "common.aroundMe": "У мојој близини",
  "common.articleCount": "{count, plural, one {# чланак} few {# чланка} other {# чланака}}",
  "common.articleNotFound": "Чланак није пронађен",
  "common.articleNotFoundDescription": "Чланак који тражите не постоји.",
  "common.average": "Просек",
  "common.averageOverThePeriod": "Просек током периода",
  "common.away": "Одсутност",
  "common.back": "Назад",
  "common.backToHelpCenter": "Назад у центар за помоћ",
  "common.backToHome": "Назад на Почетну",
  "common.bad": "Лоше",
  "common.batteryLevel": "Ниво батерије",
  "common.bestValue": "Најбоља Вредност",
  "common.billingDetailsAndroid": "Бесплатна пробна верзија вам неће бити наплаћена уколико одустанете 24 часа пре истека пробног периода. Када пробни период заврши, можете да откажете претплату на SmartMixin у било ком тренутку преко Google Play-а, а у супротном ће претплата аутоматски да се обнавља. Ово морате да урадите бар 24 часа пре истека периода претплате како бисте избегли наплату за још један период у износу назначеном у дугмету изнад. Плаћање претплате ће бити обављено кроз Google Play када потврдите куповину и након испуњења услова за обнављање претплате за сваки следећи период.",
  "common.billingDetailsIos": "Бесплатна пробна верзија вам неће бити наплаћена уколико одустанете 24 часа пре истека пробног периода. Када пробни период заврши, можете да откажете претплату на SmartMixin у било ком тренутку преко ваше продавнице апликација, а у супротном ће претплата аутоматски да се обнавља. Ово морате да урадите бар 24 часа пре истека периода претплате како бисте избегли наплату за још један период у износу назначеном у дугмету изнад. Плаћање претплате ће бити обављено кроз вашу продавницу апликација када потврдите куповину и након испуњења услова за обнављање претплате за сваки следећи период.",
  "common.boilerOn": "Бојлер УКЉУЧЕН",
  "common.browseByCategory": "Прегледај по категорији",
  "common.calendarView": "Календарски преглед",
  "common.cancel": "Откажи",
  "common.cannotBeEmpty": "Ово поље не може бити празно.",
  "common.cardDetails": "Детаљи картице",
  "common.categoryNotFound": "Категорија није пронађена",
  "common.categoryNotFoundDescription": "Ова категорија не постоји или нема чланака.",
  "common.charts": "Дијаграми",
  "common.chartView": "Преглед дијаграма",
  "common.clearRecentLocations": "Очистити све",
  "common.close": "Затвори",
  "common.co2Fresh": "Свеж",
  "common.co2GettingStale": "Погоршава се",
  "common.co2Stale": "Загушљив",
  "common.comparison": "Поређења",
  "common.contactMe": "Контактирајте ме",
  "common.currentDay": "Данас",
  "common.currentLocation": "Тренутна локација",
  "common.currentObservations": "Тренутне вредности",
  "common.currentRainEvent": "Тренутни догађај кише",
  "common.currentRate": "Интензитет кише",
  "common.currentWeatherConditions": "Тренутни услови",
  "common.customizeComparisonMetrics": "Прилагодите метрике",
  "common.customizeComparisonMetricsDescription": "Превлачите ставке да бисте поново организовали метрике поређења. Додирните икону ока да бисте приказали или скрили метрике.",
  "common.customizeDashboard": "Прилагоди",
  "common.customizeDashboardDescription": "Превуците ставке да промените редослед на контролној табли. Додирните икону ока да прикажете или сакријете секције.",
  "common.customizedStationName": "Прилагођено име станице",
  "common.dailyForecast": "Дневна прогноза",
  "common.dashboard": "Преглед",
  "common.dayRangeExpected": "{value} се очекује у {time}",
  "common.dayRangeReached": "{value} у {time}",
  "common.dayRangeSteady": "Стабилно {value} цео дан",
  "common.default": "Подразумевано",
  "common.defaultForecastModelChip": "Подразумевано · {name}",
  "common.delete": "Обриши",
  "common.deleteAccount": "Обрисати налог",
  "common.deleteAccountConfirmation": "Да ли сте сигурни да желите да избришете свој налог? Ова акција је неповратна.",
  "common.deleteAccountDescription": "Ова радња брише ваш налог и све ваше информације. Нема повратка.",
  "common.details": "Детаљи",
  "common.durationHours": "{hours} ч",
  "common.durationHoursMinutes": "{hours} ч {minutes} мин",
  "common.durationMinutes": "{minutes} мин",
  "common.durationMinutesSeconds": "{minutes} мин {seconds} с",
  "common.durationSeconds": "{seconds} с",
  "common.edit": "Уреди",
  "common.editor": "Уређивач",
  "common.endTime": "КРАЈ",
  "common.evening": "Вече",
  "common.exitFullscreen": "Изађи из целог екрана",
  "common.exploreWeatherMap": "Истражите Временску Карту",
  "common.favoriteLocations": "Фаворити",
  "common.favoriteLocationsEmpty": "Можете да додате до 5 омиљених локација.",
  "common.favoriteStations": "Омиљене станице",
  "common.feedbackHelpsImprove": "Ваше повратне информације помажу нам да побољшамо чланке помоћи.",
  "common.feedbackReasonNotAnswer": "Не одговара на моје питање",
  "common.feedbackReasonOutdated": "Информације су застареле",
  "common.feedbackReasonUnclear": "Упутства су нејасна",
  "common.feedbackWhatWentWrong": "У чему је био проблем?",
  "common.filterStationDescription": "Не приказуј станице са непоузданим мерењима.",
  "common.filterStations": "Филтрирај станице",
  "common.filterStationSourceDescription": "Изаберите добављаче станица које желите да прикажете на мапи",
  "common.findStationsNearYou": "Пронађите станице у близини",
  "common.firmwareVersion": "Верзија фирмвера",
  "common.forecast": "Прогноза",
  "common.forecastAllModels": "Сви модели ({count})",
  "common.forecastComparisonDescription": "Лако упоредите податке из различитих доступних временских модела",
  "common.forecastFollowingPreferences": "Према вашим подешавањима",
  "common.forecastModelComparison": "Поређење временских модела",
  "common.forecastModelCoverage": "Покривеност",
  "common.forecastModelDescription": "Опис",
  "common.forecastModelDescription_AROME": "Високорезолуциони модел Météo Francea који омогућава разлучивање конвекције над западном Европом са резолуцијом од 1,3 км. Најбољи у класи за краткорочне прогнозе у Француској; ажурира се сваких три сата.",
  "common.forecastModelDescription_ARPEGE_EU": "Европско гнездо модела ARPEGE Météo Francea са резолуцијом од 10 км. Средњорочне прогнозе над Европом, ажурирају се четири пута дневно.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Глобални нумерички модел времена Météo Francea са резолуцијом од 25 км, до отприлике 4 дана. Ажурира се четири пута дневно.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI од DMI: модел који омогућава конвекцију над северозападном Европом — Данска, Бенелукс, Ирска, Уједињено Краљевство и Скандинавија — са резолуцијом од 2 км који иде до 60 сати, ажурира се осам пута дневно. Садржи измењене отворене податке DMI-ја (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Глобални детерминистички систем предвиђања Environment Canada: светски средњорочни модел са резолуцијом од 15 км који иде до 10 дана, ажурира се два пута дневно.",
  "common.forecastModelDescription_EC_HRDPS": "Детерминистички систем предвиђања високе резолуције Environment Canada: модел који омогућава конвекцију над Канадом и северним делом Сједињених Држава са резолуцијом од 2,5 км који иде до 48 сати, ажурира се четири пута дневно.",
  "common.forecastModelDescription_EC_RDPS": "Регионални детерминистички систем предвиђања Environment Canada: средњорочни модел над Северном Америком са резолуцијом од 10 км, ажурира се четири пута дневно.",
  "common.forecastModelDescription_ECMWF_HRES": "Водећи модел високе резолуције (IFS) Европског центра за средњорочне временске прогнозе, широко сматран најбољим глобалним прогностичким системом на свету. Покрива целу планету резолуцијом од 25 км до 15 дана, ажурира се четири пута дневно. Садржи измењене отворене податке ECMWF-а (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Водећи средњорочни глобални модел NOAA. Покрива целу планету са резолуцијом од 25 км до 16 дана, ажурира се четири пута дневно.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh од NOAA: модел који омогућава разлучивање конвекције над континенталним САД са резолуцијом од 3 км, ажурира се сваких сат. Најпогоднији за веома краткорочне прогнозе грмљавинских олуја и јаког времена.",
  "common.forecastModelDescription_ICON": "DWD-ov globalni model ICON rezolucije 13 km koji pokriva celu planetu do 7,5 dana, ažurira se četiri puta dnevno. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I агенције ItaliaMeteo, који се изводи заједно са ARPAE: модел који омогућава конвекцију над Италијом са резолуцијом од 2,2 км који иде до 72 сата, ажурира се двапут дневно. Садржи отворене податке ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Контролно извођење модела ICON-CH1-EPS агенције MeteoSwiss: модел који омогућава конвекцију над Алпима са резолуцијом од 1 км који иде до 33 сата, ажурира се свака три сата.",
  "common.forecastModelDescription_ICON_CH2": "Контролно извођење модела ICON-CH2-EPS агенције MeteoSwiss: модел који омогућава конвекцију над Алпима — Швајцарска и околни алпски регион — са резолуцијом од 2,1 км који иде до 120 сати, ажурира се четири пута дневно.",
  "common.forecastModelDescription_ICON_DE": "Високорезолуциони модел DWD-а који омогућава разлучивање конвекције над Немачком и суседним земљама са резолуцијом од 2,2 км. Краткорочне прогнозе ажурирају се два пута дневно. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Европско гнездо модела ICON DWD-а са резолуцијом од 7 км које покрива Европу и Северни Атлантик. Средњорочне прогнозе ажурирају се четири пута дневно. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Отворена услуга прогнозе времена Норвешког метеоролошког института, која комбинује високорезолуционе нордијске моделе са подацима ECMWF да би пружила глобалне прогнозе до 10 дана унапред.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "AROME гнездо над француским Антилима (Гваделупа, Мартиник) са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "AROME гнездо над Француском Гвајаном са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "AROME гнездо над Новом Каледонијом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "AROME гнездо над Француском Полинезијом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "AROME гнездо над Реинионом и Мајотом са резолуцијом од 2,5 км. Краткорочне прогнозе ажурирају се четири пута дневно.",
  "common.forecastModelDescription_RRFS_CONUS": "NOAA-ин систем Rapid Refresh Forecast над континенталним САД резолуције 3 km. Сатне прогнозе освежавају се осам пута дневно, до 84 сата у четири главна пролаза и 18 сати у осталима.",
  "common.forecastModelDescription_RRFS_NORTH_AMERICA": "NOAA-ин систем Rapid Refresh Forecast који покрива целу Северну Америку резолуције 13 km. Сатне прогнозе до 84 сата, освежавају се четири пута дневно.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Водећа прогноза SmartMixin-а. За сваки сат на вашој локацији бирамо најбољи доступни модел — обично високорезолуциони регионални модел тамо где постоји (AROME у Француској, ICON-D2 у Немачкој, HRRR у САД, ARPEGE Europe широм континента…) и враћамо се на глобални модел другде — затим попуњавамо све празнине из суседних извора. Резултат је јединствена беспрекорна прогноза која покрива било где у свету до 14 дана, аутоматски се ажурира сваки пут када се неки од основних модела ажурира.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Власничка глобална прогноза Weatherflow која меша више нумеричких модела времена са посматрањима из своје мреже Tempest метеоролошких станица. Глобални хоризонт од 10 дана.",
  "common.forecastModelDetailTitle": "Прогностички модел",
  "common.forecastModelScopeGlobal": "Глобални",
  "common.forecastModelScopeGlobalDescription": "Овај модел покрива целу планету.",
  "common.forecastModelScopeRegional": "Регионални",
  "common.forecastModelScopeRegionalDescription": "Овај модел покрива само одређени регион.",
  "common.forecastModelSpecifications": "Спецификације",
  "common.forecastNoPinLocation": "Ниједан жељени модел не досеже ову локацију — одлучује „свуда другде”.",
  "common.forecastNoPinStation": "Ниједан жељени модел не досеже ову станицу — одлучује „свуда другде”.",
  "common.forecastNoPreferredModels": "Још нема постављених жељених модела.",
  "common.forecastOverrideElsewhere": "Ваша подешавања важе свуда другде.",
  "common.forecastPickForLocation": "Или изаберите један за ову локацију",
  "common.forecastPickForStation": "Или изаберите један за ову станицу",
  "common.forecastPinWinsLocation": "{model} — ваш први жељени модел који досеже ову локацију.",
  "common.forecastPinWinsStation": "{model} — ваш први жељени модел који досеже ову станицу.",
  "common.forecastServedNowHere": "Тренутно је овде {model}",
  "common.forecastSetForLocation": "Постављено за ову локацију",
  "common.forecastSetForStation": "Постављено за ову станицу",
  "common.forecastSettingsRowSub": "Жељени модели и шта важи свуда другде",
  "common.forecastSheetTitle": "Модел прогнозе",
  "common.forecastSources": "Извори прогнозе",
  "common.forecastStopUsingHere": "Престани да користиш овде",
  "common.forecastUseForLocation": "Користи {model} за ову локацију",
  "common.forecastUseForStation": "Користи {model} за ову станицу",
  "common.forecastUsePreferred": "Користи моје жељене моделе",
  "common.freeAccount": "Бесплатни налог",
  "common.freeSubscription": "Бесплатна претплата",
  "common.freeTrialForPeriod": "Бесплатни налог у трајању од {period} дана",
  "common.frequency": "Фреквенција",
  "common.full": "Пун",
  "common.fullscreen": "Цео екран",
  "common.getStartedFree": "Почните Бесплатно",
  "common.getUnlimitedAccess": "Неограничен приступ:",
  "common.good": "Добро",
  "common.hail": "Град",
  "common.help": "Помоћ",
  "common.helpCategoryAccount": "Налог",
  "common.helpCategoryBilling": "Наплата",
  "common.helpCategoryForecast": "Прогнозе",
  "common.helpCategoryGettingStarted": "Први кораци",
  "common.helpCategoryProviders": "Провајдери",
  "common.helpCategoryStations": "Станице",
  "common.helpCategoryTroubleshooting": "Решавање проблема",
  "common.helpCenter": "Центар за помоћ",
  "common.helpCenterDescription": "Пронађите одговоре на честа питања и сазнајте како да максимално искористите SmartMixin.",
  "common.hg": "Заштита од мраза",
  "common.hidden": "Скривено",
  "common.hiddenSensors": "Скривени сензори",
  "common.hiddenStations": "Скривене станице",
  "common.hiddenStationsDescription": "Можете да сростите станицу тако што ћете тако додирнути икону за очи.",
  "common.high": "Високо",
  "common.home": "Кућа",
  "common.homeConnectService": "Поседујете метеоролошку станицу? Повежите свој сервис",
  "common.homeInformation": "Кућне информације",
  "common.homeIntroduction": "Повежите ваше спољашње налоге како бисте уживали у могућностима програма SmartMixin.",
  "common.homeName": "Име куће",
  "common.homeSubtitle": "Ваше време, све на једном месту",
  "common.horizon": "Хоризонт",
  "common.horizonValue": "до {value} сати",
  "common.hour": "Сат",
  "common.iDontKnowYet": "Још увек не знам",
  "common.indoor": "Унутра",
  "common.lastRainEvent": "Последња киша",
  "common.lastSeen": "последњи пут {time}",
  "common.lastUpdate": "Последња провера",
  "common.legendHeavy": "Јак",
  "common.legendLight": "Слаб",
  "common.legendLightningHelp": "Боја приказује старост сваке муње у последњих {minutes} минута — најновије белом, најстарије тамноцрвеном.",
  "common.legendNewest": "Најновије",
  "common.legendOldest": "Најстарије",
  "common.legendStationsHelp": "Боја ознаке одражава вредност изабране величине.",
  "common.lightningDataAttribution": "Подаци о муњама: Blitzortung.org",
  "common.lightningStrikes": "Удари муња",
  "common.lightningStrikesDescription": "Прикажи ударе муња у реалном времену на карти",
  "common.linkToSection": "Веза ка овом одељку",
  "common.loading": "Учитавам",
  "common.location": "Локација",
  "common.locationAddedToFavorites": "Локација је додата у фаворите",
  "common.locationNotGranted": "Дозвола за локацију није одобрена. Молимо вас да дозволите приступ вашој локацији у подешавањима уређаја.",
  "common.locationRemovedFromFavorites": "Локација уклоњена из фаворита",
  "common.locations": "Локације",
  "common.low": "Ниско",
  "common.manage": "Управљај",
  "common.manageAccount": "Управљај налогом",
  "common.manageMySubscription": "Управљај претплатом",
  "common.manageSensors": "Управљање сензорима",
  "common.manageSensorsDescription": "Превуците ставке да бисте променили редослед сензора. Додирните икону ока да бисте приказали или сакрили сензоре. Додирните назив да бисте га преименовали.",
  "common.manualBoost": "Ручно повећање",
  "common.manualSetpointUntil": "Постави ручно тачку до",
  "common.mapLayers": "Слојеви карте",
  "common.mapLegend": "Легенда мапе",
  "common.maxFavoriteLocationsReached": "Можете да имате само до 5 најдражих локација. Уклоните један да бисте додали још један.",
  "common.maximum": "Максимум",
  "common.maxOverThePeriod": "Максимум током периода",
  "common.measureToDisplay": "Мера за приказ",
  "common.medium": "Средње",
  "common.meshSize": "Величина мреже",
  "common.minimum": "Минимум",
  "common.minRead": "{minutes} мин читања",
  "common.modifyFavoriteStations": "Измените омиљене станице",
  "common.modifyFavoriteStationsDescription": "Можете да преузмете своје омиљене станице повлачењем их. Такође их можете уклонити са листе.",
  "common.moduleCount": "{count, plural, one {# модул} few {# модула} other {# модула}}",
  "common.moduleType": "Тип модула",
  "common.monthTotal": "Овог месеца",
  "common.more": "Више",
  "common.moreInformation": "Више информација",
  "common.morning": "Јутро",
  "common.myLocation": "Моја локација",
  "common.nearbyWeatherStations": "Оближње метео-станице",
  "common.next": "Следећи",
  "common.nextHours": "Следећи сати",
  "common.night": "Ноћ",
  "common.no": "Не",
  "common.noAccountNeeded": "Није потребан налог",
  "common.noDataForThisPeriod": "Нема података у периоду",
  "common.noLocationsFound": "Нису пронађене локације",
  "common.noNetatmoWeatherStationYet": "Још увек немате Netatmo Метеостаницу.",
  "common.noOutdoorModule": "Није откривен нити један спољашњи модул за ову станицу.",
  "common.noSearchResults": "Ниједан чланак не одговара вашој претрази",
  "common.noStationsFound": "Нису пронађене станице",
  "common.noThermostatYet": "Немате термостат.",
  "common.notNow": "Не сада",
  "common.notPurchasedYet": "Изгледа да овај производ још увек нисте купили.",
  "common.notReachable": "Недоступан",
  "common.now": "Сада",
  "common.noWeatherStation": "Немате метеостаницу",
  "common.noWeatherStationYet": "Још увек немате метеостаницу.",
  "common.numberOfActiveWarnings": "{warning_count} активних упозорења о времену",
  "common.onThisPage": "На овој страници",
  "common.openSettings": "Отвори подешавања",
  "common.orChooseMonthly": "Или одабери месечно:",
  "common.outdoor": "Вани",
  "common.outdoorTemperature": "Вањска температура",
  "common.pageNotFound": "Страница Није Пронађена",
  "common.pageNotFoundDescription": "Страница коју тражите не постоји или је премештена.",
  "common.passwordUpdated": "Лозинка је успешно промењена.",
  "common.personalWeatherIntelligence": "Ваша Лична Временска Интелигенција",
  "common.platformMobileApp": "Мобилна апликација",
  "common.platformMobileOnly": "Само у мобилној апликацији",
  "common.platformWebApp": "Веб апликација",
  "common.platformWebOnly": "Само у веб апликацији",
  "common.popularArticles": "Популарни чланци",
  "common.premiumAccount": "Премијум налог",
  "common.premiumDescription": "Премијум налог откључава велики број додатних могућности попут напредне анализе времена, упоредних дијаграма, локалних прогностичких модела и још много тога.",
  "common.premiumFeatureAlerts": "Временска Упозорења",
  "common.premiumFeatureAnalysis": "Напредна Анализа Времена",
  "common.premiumFeatureCharts": "Упоређивање Графикона",
  "common.premiumFeatureExport": "Извоз Података",
  "common.premiumFeatureForecast": "Регионални Прогностички Модели",
  "common.premiumFeatureNotification": "Виџет Статусне Траке",
  "common.premiumFeatureTitle": "Премијум Функција",
  "common.premiumFeatureWidgets": "Виџети почетног екрана",
  "common.pressureSummary": "Синтеза притиска",
  "common.previous": "Претходни",
  "common.previousHours": "Претходни сати",
  "common.profileUpdated": "Профил је успешно ажуриран.",
  "common.purchasedNetatmoPro": "Претходно сте купили Netatmo Pro ({date}). Претплатите се на једну од доле наведених понуда да бисте имали приступ свим премиум функцијама апликације.",
  "common.radarDataAttribution": "Подаци радара: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Киша",
  "common.rainEvents": "Кишни догађаји",
  "common.rainfallMeasurement": "Мерење количине падавина",
  "common.rainRadar": "Радар падавина",
  "common.rainRadarDescription": "Прикажите преклапање радара за кишу на мапи",
  "common.rainSummary": "Резиме падавина",
  "common.range": "Интервал",
  "common.recentLocations": "Недавни",
  "common.recentLocationsEmpty": "Недавна историја је празна.",
  "common.recentStations": "Недавне станице",
  "common.relatedArticles": "Повезани чланци",
  "common.relay": "Релеј",
  "common.removeFromFavorites": "Уклони из омиљених",
  "common.renameSensors": "Преименовање сензора",
  "common.resetZoom": "Ресетуј увећање",
  "common.restorePurchase": "Обнови куповину",
  "common.room": "Просторија",
  "common.rooms": "Просторије",
  "common.savingsPercent": "Уштедите {percent}%",
  "common.searchArticles": "Претражи чланке...",
  "common.searchForALocation": "Претражите локацију...",
  "common.searchForLocation": "Потражи локацију",
  "common.searchForWeatherStation": "Потражи метеостаницу",
  "common.searchResults": "Резултати претраге",
  "common.searchResultsEmpty": "Нема резултата.",
  "common.searchResultsFound": "{count, plural, one {Пронађен # резултат} few {Пронађена # резултата} other {Пронађено # резултата}}",
  "common.searchStationsDescription": "Унесите град, адресу или назив места да бисте пронашли метеоролошке станице у близини.",
  "common.searchStationsHint": "Користите траку за претрагу изнад да бисте открили метеоролошке станице било где у свету.",
  "common.selectStationForComparison": "Изаберите станицу за поређење",
  "common.selectWeatherForecastProvider": "Изаберите добављача временске прогнозе",
  "common.serialNumber": "Серијски број",
  "common.share": "Подели",
  "common.shareOutdoorMeasures": "Поделите ваша спољашња мерења",
  "common.shareOutdoorMeasuresDescription": "Учествујте у заједници корисника апликације SmartMixin тако што ћете поделити мерења са вашег спољашњег модула. Мерења са унутрашњег модула никада неће бити дељена.",
  "common.shareYourWeather": "Поделите ваше временске услове",
  "common.signalAverage": "Умерен",
  "common.signalBad": "Слаб",
  "common.signalGood": "Добар",
  "common.signalStrength": "Јачина сигнала",
  "common.signalUnknown": "Непознат",
  "common.skip": "Прескочити",
  "common.smartThermostat": "Паметни термостат",
  "common.smartValve": "Паметни вентил",
  "common.snow": "Снег",
  "common.start": "Почети",
  "common.startFreeTrial": "Започните Бесплатни Пробни Период",
  "common.startTime": "Почетак",
  "common.station": "станица",
  "common.stationAddedToFavorites": "Станица је додата у омиљене",
  "common.stationComparison": "Поређење станица",
  "common.stationComparisonDescription": "Омогућава вам да упоредите историјске временске податке са подацима друге станице.",
  "common.stationInformation": "Информације о станици",
  "common.stationName": "Назив станице",
  "common.stationObservationsDescription": "Прикажите најновија запажања са метеоролошких станица",
  "common.stationRemovedFromFavorites": "Станица је уклоњена из омиљених",
  "common.stations": "станице",
  "common.stationsNear": "Станице у близини",
  "common.stationType": "Тип станице",
  "common.statusOffline": "Ван мреже",
  "common.statusOnline": "На мрежи",
  "common.statusStale": "Застарело",
  "common.statusSyncing": "Синхронизација",
  "common.stillNeedHelp": "И даље вам је потребна помоћ?",
  "common.stillNeedHelpDescription": "Ако овај чланак није одговорио на ваше питање, радо ћу вам помоћи директно.",
  "common.subscribeNow": "Претплати се сада - без пробног периода",
  "common.sumOverThePeriod": "Акумулирано током периода",
  "common.switchToPremium": "Пређи на SmartMixin Premium",
  "common.temperatureShort": "Темп.",
  "common.temperatureSummary": "Резиме температуре",
  "common.thankYouForFeedback": "Хвала на повратним информацијама!",
  "common.thenPrice": "затим {price}",
  "common.timeSelection": "Избор периода",
  "common.timezone": "Временска зона",
  "common.totalDuration": "Укупно трајање",
  "common.tryAnotherLocation": "Нисмо могли да пронађемо метеоролошке станице у близини ове локације. Покушајте да претражујете у другом подручју.",
  "common.unknown": "Непознат",
  "common.untilChanged": "Док се не промени",
  "common.untilTime": "до {time}",
  "common.updateAvailable": "Доступно је ажурирање",
  "common.updateAvailableOpenAppStore": "Додирните да отворите App Store",
  "common.updateAvailableOpenGooglePlay": "Додирните да отворите Google Play",
  "common.updateAvailableVersion": "Доступно је ажурирање: v{version}",
  "common.upgrade": "Надогради",
  "common.upgradeRequiredAndroid": "Потребна је надоградња апликације. Посетите Google Play ради надоградње.",
  "common.upgradeRequiredIos": "Потребна је надоградња апликације. Идите у ваши продавницу апликација ради надоградње.",
  "common.validate": "Потврди",
  "common.validEmail": "Потребна је важећа адреса е-поште.",
  "common.very_low": "Веома ниско",
  "common.viewAsList": "Листа",
  "common.viewAsPeriods": "Периоди",
  "common.visitNetatmoWebsite": "Посетите сајт Netatmo",
  "common.wasArticleHelpful": "Да ли вам је овај чланак био користан?",
  "common.weatherCondition": "Услови времена",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain је додатни извор података који се обезбеђује преко Tempest Weather System-а, који покреће технологија Nearcast. Подаци о NC Rain су процена просечне акумулације падавина око вашег Tempest-а на нивоу суседства",
  "common.weatherForecastModels": "Модели временске прогнозе",
  "common.weatherIntelligencePlatform": "Платформа Временске Интелигенције",
  "common.weatherMap": "Метеокарта",
  "common.weatherMapMetaDescription": "SmartMixin нуди интерактивне мапе времена и радара за временске услове широм света.",
  "common.weatherObservations": "Временска запажања",
  "common.weatherStation": "Метеостаница",
  "common.weatherStations": "Метеостанице",
  "common.welcome": "Добродошли у SmartMixin!",
  "common.whenBackHome": "Када се враћате кући?",
  "common.wifiStrength": "Јачина сигнала WiFi",
  "common.wind": "Ветар",
  "common.windMeasurement": "Мерења ветра",
  "common.windSpeed": "Брзина ветра",
  "common.windSummary": "Синтеза ветра",
  "common.yearToDate": "Ове године",
  "common.yes": "да",
  "common.zoomImage": "Увећај слику",
  "forecastMaps.addColor": "Додај боју",
  "forecastMaps.addLayer": "Додај слој",
  "forecastMaps.autoPreview": "Ауто",
  "forecastMaps.backToMaps": "Назад на карте",
  "forecastMaps.browseMaps": "Прегледај карте",
  "forecastMaps.build": "Генериши",
  "forecastMaps.buildCompleted": "Генерисање завршено",
  "forecastMaps.builderMetaDescription": "Саставите сопствене прогностичке карте од слојева метеоролошких модела.",
  "forecastMaps.builderTitle": "Израда карата",
  "forecastMaps.buildFailed": "Генерисање није успело. Покушајте поново.",
  "forecastMaps.buildNotPossible": "Ова карта се још не може генерисати — нема доступних прогностичких података.",
  "forecastMaps.buildProgress": "Исцртавање… {completed}/{total} корака",
  "forecastMaps.buildStarting": "Покретање генерисања…",
  "forecastMaps.byModel": "По моделу",
  "forecastMaps.byZone": "По зони",
  "forecastMaps.colormap": "Палета боја",
  "forecastMaps.colormapCustom": "Прилагођене боје",
  "forecastMaps.colormapGroupDomain": "Метеоролошки шаблони",
  "forecastMaps.colormapGroupMatplotlib": "Научни шаблони",
  "forecastMaps.colorScale": "Skala boja",
  "forecastMaps.comingSoon": "Овај приказ ускоро стиже.",
  "forecastMaps.contourLevels": "Нивои изолинија",
  "forecastMaps.countryCanada": "Канада",
  "forecastMaps.countryFrance": "Француска",
  "forecastMaps.countryGermany": "Немачка",
  "forecastMaps.countryItaly": "Италија",
  "forecastMaps.countryScandinavia": "Скандинавија",
  "forecastMaps.countrySpain": "Шпанија",
  "forecastMaps.countrySwitzerland": "Швајцарска",
  "forecastMaps.countryUnitedStates": "Сједињене Државе",
  "forecastMaps.customColormapMinColors": "Прилагођена палета боја захтева најмање две боје",
  "forecastMaps.customExtent": "Прилагођени обухват",
  "forecastMaps.deleteMap": "Обриши карту",
  "forecastMaps.deleteMapBody": "„{name}” и њена исцртавања биће трајно обрисани.",
  "forecastMaps.deleteMapTitle": "Обрисати ову карту?",
  "forecastMaps.displayName": "Приказани назив",
  "forecastMaps.downloadMp4": "Преузми MP4",
  "forecastMaps.downscaling": "Фактор проређивања ветровних заставица",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Нацртај област",
  "forecastMaps.east": "Исток",
  "forecastMaps.editMap": "Уреди карту",
  "forecastMaps.exportBuilding": "Припрема видео-снимка…",
  "forecastMaps.exportError": "Извоз видео-снимка није успео. Покушајте поново.",
  "forecastMaps.exportMp4": "Извези MP4",
  "forecastMaps.exportNotReady": "Видео-снимак још није спреман. Покушајте поново касније.",
  "forecastMaps.extentDrawHint": "Превуците по карти да бисте нацртали област",
  "forecastMaps.extentInvalid": "Запад мора бити мањи од истока, а југ мањи од севера",
  "forecastMaps.extentPanZoomHint": "Померајте и зумирајте док област не испуни оквир",
  "forecastMaps.flipbookView": "Анимација",
  "forecastMaps.forecastModel": "Прогностички модел",
  "forecastMaps.forkAndEdit": "Дуплирај и уреди",
  "forecastMaps.height": "Висина (инчи)",
  "forecastMaps.hourOffset": "+{hour} ч",
  "forecastMaps.invalidHexColor": "Неважећа боја — користите #RRGGBB",
  "forecastMaps.layers": "Слојеви",
  "forecastMaps.layerTypeBarbs": "Ветровне заставице",
  "forecastMaps.layerTypeContour": "Изолиније",
  "forecastMaps.layerTypeFilledContour": "Испуњене изолиније",
  "forecastMaps.layerTypeMagnitude": "Магнитуда",
  "forecastMaps.layerTypeRaster": "Растер",
  "forecastMaps.layerTypeVectorField": "Векторско поље",
  "forecastMaps.leave": "Изађи",
  "forecastMaps.levelsCount": "Број",
  "forecastMaps.levelsInvalid": "Неважећи нивои изолинија",
  "forecastMaps.levelsModeArange": "Фиксни корак",
  "forecastMaps.levelsModeExplicit": "Експлицитне вредности",
  "forecastMaps.levelsModeLinspace": "Равномерно распоређено (број)",
  "forecastMaps.levelsStep": "Корак",
  "forecastMaps.levelsValues": "Вредности",
  "forecastMaps.levelsValuesHint": "Одвојене зарезима, растуће",
  "forecastMaps.localTimeHint": "Приказано по вашем локалном времену",
  "forecastMaps.map": "Карта",
  "forecastMaps.mapDescription": "Опис",
  "forecastMaps.mapName": "Назив карте",
  "forecastMaps.mapNameRequired": "Унесите назив",
  "forecastMaps.mapSettings": "Подешавања карте",
  "forecastMaps.mapView": "Интерактивна мапа",
  "forecastMaps.maxLayersReached": "Ова карта је достигла максимум од {max} слојева.",
  "forecastMaps.maxValue": "Максимална вредност",
  "forecastMaps.memoryBudgetExceeded": "Резолуција премашује буџет исцртавања — смањите DPI или висину",
  "forecastMaps.memoryBudgetUsage": "Буџет исцртавања: {percent}%",
  "forecastMaps.metaDescription": "Анимиране прогностичке карте израђене из прорачуна метеоролошких модела.",
  "forecastMaps.metric": "Величина",
  "forecastMaps.metricRequired": "Изаберите величину",
  "forecastMaps.metricUnavailable": "Није доступно за овај модел",
  "forecastMaps.minBelowMax": "Минимум мора бити мањи од максимума",
  "forecastMaps.minMaxRequired": "Минимална и максимална вредност су обавезне за ову врсту слоја",
  "forecastMaps.minValue": "Минимална вредност",
  "forecastMaps.modelNoRun": "Још нема завршеног прорачуна",
  "forecastMaps.moveLayerDown": "Помери надоле",
  "forecastMaps.moveLayerUp": "Помери нагоре",
  "forecastMaps.myMaps": "Моје карте",
  "forecastMaps.nanClipToMin": "Ограничи на минимум",
  "forecastMaps.nanMask": "Маскирај",
  "forecastMaps.nanPolicy": "Недостајући подаци",
  "forecastMaps.nanSkip": "Прескочи",
  "forecastMaps.newMap": "Нова карта",
  "forecastMaps.noCompletedRun": "Ова карта још није израђена. Проверите поново ускоро.",
  "forecastMaps.noLayers": "Још нема слојева. Додајте слој за почетак.",
  "forecastMaps.noMapsAvailable": "Прогностичке карте још нису доступне.",
  "forecastMaps.north": "Север",
  "forecastMaps.opacity": "Непрозирност",
  "forecastMaps.overlayLegend": "Легенда",
  "forecastMaps.pause": "Пауза",
  "forecastMaps.play": "Репродукуј",
  "forecastMaps.pointValueError": "Прогноза за ову тачку није могла да се учита.",
  "forecastMaps.pointValueLoading": "Учитавање прогнозе…",
  "forecastMaps.pointValueUnavailable": "Нема података за ово време.",
  "forecastMaps.presets": "Шаблони",
  "forecastMaps.preview": "Преглед",
  "forecastMaps.previewEmptyHint": "Подесите бар један исправан слој за исцртавање прегледа.",
  "forecastMaps.previewFailed": "Преглед није успео",
  "forecastMaps.previewHour": "Сат прогнозе",
  "forecastMaps.previewRendering": "Исцртавање прегледа…",
  "forecastMaps.projection": "Пројекција",
  "forecastMaps.projectionLambertConformal": "Ламбертова конформна",
  "forecastMaps.projectionMercator": "Меркаторова",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Стереографска",
  "forecastMaps.regionEurope": "Европа",
  "forecastMaps.regionNorthAmerica": "Северна Америка",
  "forecastMaps.removeColor": "Уклони боју",
  "forecastMaps.removeLayer": "Уклони слој",
  "forecastMaps.retry": "Покушај поново",
  "forecastMaps.run": "Прорачун: {run}",
  "forecastMaps.save": "Сачувај",
  "forecastMaps.selectExtentOnMap": "Изабери област на карти",
  "forecastMaps.south": "Југ",
  "forecastMaps.title": "Прогностичке карте",
  "forecastMaps.uMetric": "U-компонента",
  "forecastMaps.unitConversion": "Претварање јединица",
  "forecastMaps.unitNone": "Без претварања",
  "forecastMaps.unsavedChangesBody": "Имате несачуване измене. Изаћи и одбацити их?",
  "forecastMaps.unsavedChangesTitle": "Несачуване измене",
  "forecastMaps.useCurrentView": "Користи тренутни приказ",
  "forecastMaps.useModelDomain": "Искључено: користи се цела област модела",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Величине U и V морају се разликовати",
  "forecastMaps.validTime": "Важи: {time}",
  "forecastMaps.valueBetween": "Мора бити између {min} и {max}",
  "forecastMaps.variable": "Променљива",
  "forecastMaps.viewMap": "Прикажи карту",
  "forecastMaps.vMetric": "V-компонента",
  "forecastMaps.west": "Запад",
  "forecastMaps.windAnimation": "Анимација ветра",
  "intro.locationDescription": "Омогућите приступ локацији за прецизне временске прогнозе прилагођене вашем тачном подручју — без универзалних прогноза.",
  "intro.locationTitle": "Прогнозе направљене за вас",
  "intro.notificationDescription": "Укључите обавештења за правовремена упозорења о временским променама које су вам важне — киша, снег или тешки услови, баш када треба.",
  "intro.notificationsTitle": "Никада не пропустите промену времена",
  "intro.readyDescription": "Уживајте у прецизним прогнозама, временским увидима у реалном времену и подацима са станица широм света — све у једној моћној апликацији.",
  "intro.readyTitle": "Спремни сте!",
  "intro.welcomeDescription": "Добијте хиперлокалне прогнозе од најбољих метеоролошких агенција — плус приступ преко 40.000 метеоролошких станица широм света за реалне услове, прошле и садашње.",
  "intro.welcomeTitle": "Ваша временска прогноза, осмишљена изнова",
  "landing.alerts": "Алертс",
  "landing.alertsDescription": "Креирајте сопствена упозорења и добијајте обавештења чим се активирају.",
  "landing.featureAlertsDescription": "Поставите прилагођена упозорења за услове који вас занимају—температура, ветар, падавине и више.",
  "landing.featureAlertsTitle": "Паметна упозорења",
  "landing.featureAnalyticsDescription": "Уроните у своје податке са интерактивним графиконима, упоређивањима један поред другог и анализом трендова изван основних метрика.",
  "landing.featureAnalyticsTitle": "Моћна аналитика",
  "landing.featureExportDescription": "Преузмите своје податке у CSV формату за анализу у Excel-у, интеграцију са другим системима или резервну копију.",
  "landing.featureExportTitle": "Извоз било где",
  "landing.featureForecastDescription": "Упоредите прогнозе из више од 10 метеоролошких модела укључујући GFS, ECMWF, ICON и друге да видите који најбоље функционише за вашу локацију.",
  "landing.featureForecastTitle": "Упоређивање прогноза",
  "landing.featureHistoryDescription": "Приступ историјским подацима са сатном, дневном и месечном скалом. Извоз у CSV за истраживање или личне архиве.",
  "landing.featureHistoryTitle": "Богата историја",
  "landing.featureMultiBrandDescription": "Повежите станице од Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow и других—све на једној контролној табли.",
  "landing.featureMultiBrandTitle": "Подршка за више марки",
  "landing.featuresSubtitle": "Дизајнирано за љубитеље времена који захтевају више од основне апликације метеоролошке станице.",
  "landing.featuresTitle": "Све што вам треба за анализу времена",
  "landing.finalCtaButton": "Направите бесплатан налог",
  "landing.finalCtaSubtitle": "Придружите се хиљадама љубитеља времена који верују SmartMixin-у за своје временске податке.",
  "landing.finalCtaTitle": "Спремни да побољшате своје временско искуство?",
  "landing.forecastDescription": "Приступите неким од најбољих модела временске прогнозе и упоредите их да бисте стекли своју идеју какво ће бити време.",
  "landing.forecasts": "Прогнозе",
  "landing.heroCta": "Почните бесплатно",
  "landing.heroDescription": "Повежите више метеоролошких станица било које марке, упоредите моделе прогнозе и анализирајте своје податке са детаљним графиконима и извозом.",
  "landing.heroSecondaryCta": "Погледајте функције",
  "landing.heroTagline": "За љубитеље времена",
  "landing.heroTitle": "Сви временски подаци. Једна платформа.",
  "landing.pricingFeatureAdvancedMetrics": "Напредне метрике",
  "landing.pricingFeatureAlerts": "Прилагођена упозорења",
  "landing.pricingFeatureExport": "Извоз података (CSV)",
  "landing.pricingFeatureForecastComparison": "Поређење прогноза",
  "landing.pricingFeatureForecasts": "Модели прогнозе",
  "landing.pricingFeatureForecastsFreeTier": "1 модел",
  "landing.pricingFeatureForecastsPremiumTier": "Сви модели (10+)",
  "landing.pricingFeatureReports": "Анализе и извештаји",
  "landing.pricingFeatureStationComparison": "Поређење станица",
  "landing.pricingFeatureWidgets": "Виџети за почетни екран",
  "landing.pricingFeatureYearOverYear": "Анализа година за годином",
  "landing.pricingFree": "Бесплатно",
  "landing.pricingFreeCta": "Почните",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Најпопуларније",
  "landing.pricingPremium": "Премиум",
  "landing.pricingPremiumCta": "Започните",
  "landing.pricingPremiumDescription": "Од 1,99 €/месец — претплатите се на вебу, App Store-у или Google Play-у",
  "landing.pricingSubtitle": "Почните бесплатно, надоградите када вам треба више.",
  "landing.pricingTitle": "Једноставне, транспарентне цене",
  "landing.smartMixinDescription": "SmartMixin је апликација која омогућава приступ вашој метеоролошкој станици и 40К+ другим станицама широм света. Помаже вам да видите и разумете временске податке.",
  "landing.statBrands": "Подржане марке",
  "landing.statForecasts": "Модела прогнозе",
  "landing.statStations": "Повезаних станица",
  "landing.supportedDevices": "Подржани уређаји",
  "landing.supportedDevicesDescription": "Поред станица Светске метеоролошке организације, SmartMixin подржава све већи број брендова метеоролошких станица.",
  "landing.supportedDevicesNote": "Плус преко 40.000 јавних станица Светске метеоролошке организације",
  "landing.supportedDevicesSubtitle": "Повежите метеоролошке станице водећих марки и прегледајте све податке на једном месту.",
  "landing.supportedDevicesTitle": "Ради са вашим станицама",
  "landing.thermostatDescription": "Повежите свој Netatmo термостат да упоредите обрасце грејања са спољашњим условима.",
  "landing.thermostatManufacturers": "Произвођачи термостата такође имају подршку да повезују грејање са спољним условима.",
  "landing.thermostatTitle": "Интеграција са паметним домом",
  "landing.weatherAnalysis": "Анализа времена",
  "landing.weatherAnalysisDescription": "SmartMixin долази са пуно визуелизације података која вам омогућава да анализирате временске податке.",
  "landing.weatherAssistant": "Ваш временски помоћник",
  "landing.weatherAssistantDescription": "Без обзира да ли сте заинтересовани за тренутне, историјске или прогнозиране временске прилике, SmartMixin пружа бројне увиде кад год вам затребају.",
  "landing.weatherForecastModels": "Модели временске прогнозе",
  "landing.weatherForecastModelsDescription": "SmartMixin омогућава приступ најпрецизнијим моделима временске прогнозе. Можете лако упоредити њихове прогнозе и направити своју идеју.",
  "landing.weatherMap": "Временска карта",
  "landing.weatherMapDescription": "Прегледајте мапу и визуализујте какво је време било где широм света.",
  "network.cancelError": "Захтев је отказан",
  "network.connectionError": "Сервер је недоступан",
  "network.networkError": "Мрежа није доступна",
  "network.serverError": "Нешто је погрешно...",
  "network.timeoutError": "Повезивање је истекло",
  "network.unknownError": "Непозната грешка",
  "providerHints.ambientWeatherApiKey": "Креирано у подешавањима налога на ambientweather.net.",
  "providerHints.davisApiSecret": "Приказује се само једном приликом креирања V2 API кључа — чувајте га безбедно.",
  "providerHints.davisV2ApiKey": "Са странице V2 API кључева на weatherlink.com.",
  "providerHints.ecowittApi": "Са странице API вашег Ecowitt налога.",
  "providerHints.ecowittApp": "Кључ апликације, такође из вашег Ecowitt налога.",
  "providerHints.myAcuriteCredentialsBanner": "Користите e-mail и лозинку вашег My AcuRite налога — не SmartMixin пријаву.",
  "providerHints.myAcuriteEmail": "E-mail вашег My AcuRite налога — не ваша SmartMixin пријава.",
  "providerHints.myAcuritePassword": "Лозинка вашег My AcuRite налога.",
  "providerHints.weatherflowToken": "Токен за личну употребу са tempestwx.com → подешавања → ауторизације података.",
  "providerHints.wundergroundEditKey": "Користи други кључ",
  "providerHints.wundergroundKey": "Дугачак низ знакова са странице API кључева вашег Weather Underground налога — не ваша лозинка за wunderground.com.",
  "providerHints.wundergroundKeyExample": "нпр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API кључ проверен",
  "providerHints.wundergroundKeyVerifying": "Провера кључа…",
  "providerHints.wundergroundNoStationsNearby": "Није пронађена ниједна станица у близини. Покушајте да унесете ID станице директно.",
  "providerHints.wundergroundStationId": "Било која ознака станице Weather Underground — ваша или јавна станица у близини.",
  "providerHints.wundergroundStationIdExample": "нпр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Набавите свој Ambient Weather API кључ.",
  "providerIntro.davisStep2": "Набавите свој Davis V2 API кључ и API тајну.",
  "providerIntro.ecowittStep2": "Набавите свој Ecowitt API кључ и кључ апликације.",
  "providerIntro.getStarted": "Започни",
  "providerIntro.myAcuriteStep2": "Користите e-mail и лозинку свог постојећег My AcuRite налога.",
  "providerIntro.netatmoEnergyStep2": "Пријавите се на Netatmo када будете упитани — API кључ није потребан.",
  "providerIntro.netatmoWeatherStep2": "Пријавите се на Netatmo када будете упитани — API кључ није потребан.",
  "providerIntro.signupBanner": "Скоро готово — креирајте свој бесплатни SmartMixin налог за повезивање {provider}.",
  "providerIntro.step1": "Пријавите се на свој SmartMixin налог (НЕ на {provider}).",
  "providerIntro.step3EmailPassword": "Унесите их овде.",
  "providerIntro.step3KeyOrToken": "Налепите овде.",
  "providerIntro.step3OAuth": "Ауторизујте SmartMixin у искачућем прозору.",
  "providerIntro.step3Wunderground": "Налепите свој API кључ, затим изаберите оближњу станицу или унесите било који ID станице.",
  "providerIntro.title": "Повежи {provider}",
  "providerIntro.weatherflowStep2": "Набавите свој лични Tempest токен.",
  "providerIntro.wundergroundBrowsePublic": "Немате станицу? Прегледајте јавне",
  "providerIntro.wundergroundFindNearby": "Пронађи станице у близини",
  "providerIntro.wundergroundOrEnterId": "Или унесите ID станице",
  "providerIntro.wundergroundStep2": "Набавите свој Weather Underground API кључ. Затим можете повезати било коју станицу — своју или јавну.",
  "reports.agroMeteorology": "Агрометеорологија",
  "reports.analysis": "Анализа",
  "reports.annualCumulativeRainfallComparison": "Поређење укупних годишњих падавина",
  "reports.annualHeatingDurationComparison": "Годишње поређење времена грејања",
  "reports.annualHeatingEfficiency": "Годишња учинковитост грејања",
  "reports.annualIndoorComparison": "Годишње поређење унутрашњег модула",
  "reports.annualIndoorReport": "Годишњи извештај о унутрашњем модулу",
  "reports.annualOutdoorComparison": "Годишње поређење спољашњег модула",
  "reports.annualOutdoorReport": "Годишњи извештај о спољашњем модулу",
  "reports.annualReport": "Годишњи извештај",
  "reports.annualSolarReport": "Годишњи соларни извештај",
  "reports.annualWaterBalance": "Годишњи биланс воде",
  "reports.annualWaterBalanceCarryOver": "Пренеси из претходне године",
  "reports.annualWaterBalanceDescription": "Водени биланс (поједностављена верзија, користе се само киша и евапотранспирација) омогућава управљање водним ресурсима",
  "reports.avgHumidity": "Просечна влажност ваздуха",
  "reports.avgMaxTemperature": "Просечна T°max",
  "reports.avgMetric": "Просек – {metric}",
  "reports.avgMinTemperature": "Просечна T°min",
  "reports.avgPressure": "Просечна вредност ваздушног притиска",
  "reports.avgTemperature": "Просечна температура",
  "reports.climateNormalPeriodOfRecord": "Период мерења ({years, plural, one {# година} few {# године} other {# година}})",
  "reports.climateNormals": "Климатске нормале",
  "reports.climateNormalStandardLabel": "Стандардна нормала ({period})",
  "reports.climateTrendPerDecade": "Тренд температуре: {value} по деценији током {years, plural, one {# године} few {# године} other {# година}}",
  "reports.coldestMonthRanking": "Најхладнији {month} у историји мерења",
  "reports.comfortable": "Угодна (45% {lessThan} влажност ваздуха ≤ 60%)",
  "reports.cumulativeRainfall": "Кумулативне падавине",
  "reports.cumulativeRainfallDescription": "Пратите укупне падавине које се акумулирају током изабраног периода.",
  "reports.dailyMaxRainfall": "Максималне дневне падавине",
  "reports.dataExport": "Извези податке",
  "reports.dataExportXlsxFormatDescription": "Извезите све ваше податке у ексел фајл (*.xlsx). Након што кликнете на дугме, након пар минута ћете добити мејл са обрађеним подацима.",
  "reports.daysOfData": "{days, plural, one {# дан} few {# дана} other {# дана}} података",
  "reports.daysWithFrost": "Дани са мразом",
  "reports.daysWithHeavyRain": "Дани са јаком кишом (≥ {threshold})",
  "reports.daysWithoutThaw": "Ледени дани (T°max < 0°C)",
  "reports.daysWithStrongFrost": "Дани са јаким мразом",
  "reports.emailSent": "Мејл је послат на вашу адресу е-поште",
  "reports.frostDays": "Мразни дани",
  "reports.grasslandTemperatureSum": "Температурна сума травњака",
  "reports.grasslandTemperatureSumDescription": "Ако је сума у пролеће већа од {threshold}, у Европи започиње одржив стар вегетације",
  "reports.growingDegreeDays": "Растући степен-дани",
  "reports.highPressure": "Антициклон (Просечна вредност притиска ≥ 1013mbar)",
  "reports.iceDays": "Ледени дани",
  "reports.indoorReport": "Извештај унутрашњег модула",
  "reports.keyFacts": "Важне чињенице",
  "reports.longestDrySpell": "Најдужи сушни период",
  "reports.longestRunOfRainyDays": "Број узастопних кишних дана",
  "reports.longestRunWithoutRun": "Број узастопних дана без кише",
  "reports.longestWetSpell": "Најдужи кишни период",
  "reports.lowPressure": "Низак притисак (просечна вредност притиска {lessThan} 1013mbar)",
  "reports.maxHumidity": "Максимална влажност",
  "reports.maxMetric": "Максимум – {metric}",
  "reports.maxPressure": "Највиши притисак",
  "reports.maxPressureMagnitude24h": "Максимална промена (/24H)",
  "reports.maxTemperature": "Највиша температура",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Максимална промена (/24H)",
  "reports.minHumidity": "Минимална влажност",
  "reports.minMetric": "Минимум – {metric}",
  "reports.minPressure": "Најнижи притисак",
  "reports.minPressureMagnitude24h": "Минимална промена (/24H)",
  "reports.minTemperature": "Најнижа температура",
  "reports.minTempMagnitude24h": "Минимална промена(/24H)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Још # дан} few {Још # дана} other {Још # дана}} овог месеца",
  "reports.monthlyAverageCountdownDetail": "Тада ће се појавити просек овог месеца и његов ранг.",
  "reports.monthlyAverageRule": "Месечни просеци и рангирања појављују се када календарски месец има забележено {days, plural, one {# дан} few {# дана} other {# дана}}.",
  "reports.monthlyHeatingEfficiency": "Месечна учинковитост грејања",
  "reports.monthlyIndoorReport": "Месечни извештај унутрашњег модула",
  "reports.monthlyOutdoorReport": "Месечни извештај спољашњег модула",
  "reports.monthlyReport": "Месечни извештај",
  "reports.monthlySolarReport": "Месечни соларни извештај",
  "reports.monthlyWindReport": "Месечни извештај о ветру",
  "reports.monthsOfData": "{months, plural, one {# месец} few {# месеца} other {# месеци}} података",
  "reports.numberOfDays": "Број дана",
  "reports.onThisDayInHistory": "На данашњи дан у историји",
  "reports.outdoorReport": "Извештај спољашњег модула",
  "reports.overviewSection": "Преглед",
  "reports.rainfall": "Падавине",
  "reports.rainyDays": "Дани са падавинама",
  "reports.recordDailyRain": "Најкишовитији дан",
  "reports.recordHigh": "Рекордна врућина",
  "reports.recordLow": "Рекордна хладноћа",
  "reports.recordsAndClimatology": "Рекорди и клима",
  "reports.recordsSince": "Рекорди од {date}",
  "reports.recordWindGust": "Најјачи удар ветра",
  "reports.relativelyWet": "Релативно влажно (60% {lessThan} Влажност ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# извештај} few {# извештаја} other {# извештаја}}",
  "reports.sendEmail": "Пошаљи мејл",
  "reports.summerDays": "Летњи дани",
  "reports.tooDry": "Сувише суво (Влажност ≤ 45%)",
  "reports.tooWet": "Спарно (Влажност {greaterThan} 80%)",
  "reports.tropicalNights": "Тропске ноћи",
  "reports.unlockPremiumSubtitle": "Укључено уз SmartMixin Premium",
  "reports.unlockPremiumTitle": "Откључајте {count, plural, one {# премијум функцију} few {# премијум функције} other {# премијум функција}}",
  "reports.warmestMonthRanking": "Најтоплији {month} у историји мерења",
  "reports.waterBalance": "Биланс воде",
  "reports.yearsOfData": "{years, plural, one {# година} few {# године} other {# година}} података",
  "reports.yearToDateTemperatureComparison": "Поређење температуре од почетка године",
  "sensors.aqiByChannel": "AQI по каналу",
  "sensors.bgtSensors": "Црна кугла и WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareAqi": "Упореди AQI",
  "sensors.compareHumidity": "Упореди влажност",
  "sensors.compareMoisture": "Упореди влагу земље",
  "sensors.comparePm25": "Упореди PM2.5",
  "sensors.compareTemperatures": "Упореди температуре",
  "sensors.depthByChannel": "Дубина по каналу",
  "sensors.heatStressExtreme": "Екстреман топлотни стрес",
  "sensors.heatStressModerate": "Умерен топлотни стрес",
  "sensors.heatStressNone": "Нема топлотног стреса",
  "sensors.heatStressStrong": "Јак топлотни стрес",
  "sensors.heatStressVeryStrong": "Веома јак топлотни стрес",
  "sensors.humidityByChannel": "Влажност по каналу",
  "sensors.indoorAirQualityPm": "PM2.5 и PM10 AQI",
  "sensors.indoorClimate": "Унутрашња клима",
  "sensors.indoorCo2Levels": "Нивои CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура и влажност",
  "sensors.last24Hours": "24 сата",
  "sensors.last30Days": "30 дана",
  "sensors.last7Days": "7 дана",
  "sensors.leafTemperatureByChannel": "Температура листова по каналу",
  "sensors.leafWetnessByChannel": "Влажност листова по каналу",
  "sensors.lightningSensor": "Муња",
  "sensors.moistureByChannel": "Влага земље по каналу",
  "sensors.noDataAvailable": "Нема доступних података",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 по каналу",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Изаберите канал",
  "sensors.sensorDetailDescription": "Прегледајте историјске податке и трендове за канале сензора.",
  "sensors.sensorHistory": "Историја сензора",
  "sensors.soilConductivityByChannel": "Проводљивост по каналу",
  "sensors.soilTemperatureByChannel": "Температура земље по каналу",
  "sensors.strikesToday": "Удари данас",
  "sensors.temperatureByChannel": "Температура по каналу",
  "sensors.viewChart": "Прикажи график",
  "settings.about": "О програму",
  "settings.aboutDescription": "Споразум о лиценци, политика приватности",
  "settings.account": "Налог",
  "settings.accountDescription": "Профил, промена лозинке",
  "settings.accountIntro": "Подаци који се тичу вашег налога:",
  "settings.accountOnHoldTitle": "Налог паузиран",
  "settings.accountSection": "Налог",
  "settings.addForecastModel": "Додај модел",
  "settings.appearance": "Изглед",
  "settings.appearanceDescription": "Тема и опције приказа",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "арапски",
  "settings.atYourStations": "Доступни на вашим станицама",
  "settings.availableServices": "Доступно",
  "settings.bulgarian": "бугарски",
  "settings.cannotDisconnectLastAccount": "Није могуће одспојити једини метод пријаве. Прво додајте други метод пријаве.",
  "settings.catalan": "каталонски",
  "settings.changeEmail": "Промени е-пошту",
  "settings.changePassword": "Промени лозинку",
  "settings.chartGestures": "Гесте на дијаграму",
  "settings.chartGesturesDescription": "Преласком преко дијаграма мењате период, скупљањем прстима мењате временску скалу",
  "settings.choiceCount": "{count, plural, one {Доступно: #} few {Доступно: #} other {Доступно: #}}",
  "settings.connect": "Повежи",
  "settings.connected": "Повезано",
  "settings.connectedAccounts": "Повезани налози",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Повезано",
  "settings.connectedSince": "Повезано од {date}",
  "settings.connectionSection": "Веза",
  "settings.connectionSuccess": "{provider} налог успешно повезан",
  "settings.contactUs": "Контактирајте нас",
  "settings.contactUsDescription": "Затражите помоћ или пошаљите повратну информацију",
  "settings.coverageLoading": "Утврђујемо које ваше станице покрива сваки модел…",
  "settings.croatian": "хрватски",
  "settings.currentPassword": "Тренутна лозинка",
  "settings.czech": "чешки",
  "settings.dailyDetailByPeriods": "Дневни детаљи по периодима",
  "settings.dailyDetailByPeriodsDescription": "Групиши 24 сата у ноћ, јутро, поподне и вече — иста подела коју користи дневни резиме.",
  "settings.dangerZone": "Ризична зона",
  "settings.danish": "дански",
  "settings.dark": "Тамна тема",
  "settings.dataDisplay": "Приказ података",
  "settings.dateAndTime": "Датум и време",
  "settings.disconnect": "Одспоји",
  "settings.disconnectConfirmation": "Да ли сте сигурни да желите одспојити {provider} налог?",
  "settings.disconnectionSuccess": "{provider} налог успешно одспојен",
  "settings.disconnectProviderDescription": "Зауставља синхронизацију. Ваша историја се чува.",
  "settings.donateButton": "Донирајте",
  "settings.donateDescription": "SmartMixin развија мали тим. Ако вам је користан, можете подржати његов развој једнократном донацијом у било ком износу. То је поклон — не мења ваш план нити откључава било какве функције.",
  "settings.donateSuccessBody": "Ваша донација помаже да SmartMixin настави да ради и да се унапређује. Искрено то ценимо.",
  "settings.donateSuccessTitle": "Хвала вам на подршци!",
  "settings.donateTitle": "Подржите SmartMixin",
  "settings.dragToReorder": "Превуците да промените редослед",
  "settings.dutch": "низоземски",
  "settings.emailChange": "Промени адресу е-поште",
  "settings.emailChangeConfirmation": "Потврда промене е-поште",
  "settings.emailChangeFailure": "Линк за промену е-поште је неважећи или је истекао.",
  "settings.emailChangeSuccess": "Ваша е-пошта је успешно промењена у {newEmail}.",
  "settings.emailChangeVerificationSent": "Верификациони е-маил је послат на вашу нову адресу е-поште. Проверите своје пријемно сандуче и кликните на линк да потврдите промену.",
  "settings.english": "енглески",
  "settings.everywhereElse": "Свуда другде",
  "settings.everywhereElseFoot": "Користи се на свакој станици до које ваши жељени модели не досежу.",
  "settings.everywhereElsePick": "Изаберите један",
  "settings.fallbackBlend": "SmartMixin мешавина",
  "settings.fallbackBlendSub": "Комбинује више модела, сваки тамо где је најјачи.",
  "settings.fallbackEcmwf": "ECMWF",
  "settings.fallbackEcmwfSub": "ECMWF HRES свуда где досеже.",
  "settings.fallbackGfs": "GFS",
  "settings.fallbackGfsSub": "NOAA-ин глобални модел. Оно што данас користи сваки налог.",
  "settings.fallbackResolution": "Највиша резолуција",
  "settings.fallbackResolutionSub": "Најфинија мрежа доступна на свакој станици.",
  "settings.forecastModels": "Модели прогнозе",
  "settings.freeBannerBody": "Бесплатни налози свуда добијају GFS — жељени модели и „свуда другде” почињу да раде чим се претплатите.",
  "settings.freeBannerTitle": "Подешавања важе уз Premium",
  "settings.french": "француски",
  "settings.german": "немачки",
  "settings.gestures": "Гесте",
  "settings.greek": "грчки",
  "settings.helpCenter": "Центар за помоћ",
  "settings.helpCenterDescription": "Често постављана питања и водичи",
  "settings.hungarian": "мађарски",
  "settings.integrationsSection": "Интеграције",
  "settings.italian": "италијански",
  "settings.japanese": "јапански",
  "settings.korean": "корејски",
  "settings.language": "Језик",
  "settings.languageDescription": "Језик по избору",
  "settings.light": "Светла тема",
  "settings.measurementUnits": "Мерне јединице",
  "settings.netatmoDashboard": "Netatmo контролна табла",
  "settings.netatmoLayoutCards": "Листа картица",
  "settings.netatmoLayoutCardsDescription": "Једна картица по модулу, све у једном померању",
  "settings.netatmoLayoutClassic": "Класични",
  "settings.netatmoLayoutClassicDescription": "Две картице, клизање између модула",
  "settings.netatmoNewLayoutNotice": "Нови распоред: једна картица по модулу.",
  "settings.netatmoSwitchBackToClassic": "Назад на класични",
  "settings.netatmoSwitchToLayout": "Пребаци на: {layout}",
  "settings.newEmailAddress": "Нова адреса е-поште",
  "settings.newPassword": "Нова лозинка",
  "settings.newPasswordAgain": "Поновите нову лозинку",
  "settings.norwegian": "норвешки",
  "settings.notConnected": "Није повезано",
  "settings.notificationsSection": "Обавештења",
  "settings.oldPassword": "Стара лозинка",
  "settings.ongoingNotificationEnabled": "Омогући трајно обавештење",
  "settings.ongoingNotificationMetrics": "Приказане метрике",
  "settings.ongoingNotificationPermissionRequired": "Потребна је дозвола за обавештења",
  "settings.ongoingNotificationPreviewHint": "Преглед — укључите виџет да би се приказао",
  "settings.ongoingNotificationStation": "Метеоролошка станица",
  "settings.ongoingNotificationStatusBar": "Статусна трака",
  "settings.passwordChange": "Промена лозинке",
  "settings.passwordChangeDescription": "Одржавајте свој налог безбедним",
  "settings.pickerShowAll": "Прикажи цео каталог",
  "settings.pickerUnreachable": "{count, plural, one {# додатни модел не досеже} few {# додатна модела не досежу} other {# додатних модела не досеже}} ниједну вашу станицу",
  "settings.pinInUse": "У употреби",
  "settings.pinShadowed": "Никада се не користи — модел изнад покрива све ваше станице",
  "settings.pinSlots": "{used} од {max} · додирните да изаберете",
  "settings.pinSlotsFull": "Свих {max} места је заузето. Уклоните једно да бисте додали друго.",
  "settings.pinsUncoveredCount": "{used} од ваших {count, plural, one {# станице} few {# станице} other {# станица}}: ниједан жељени модел не досеже до њих — одлучује „свуда другде”.",
  "settings.pinsUncoveredNamed": "{stations}: ниједан жељени модел не досеже до {count, plural, one {ње} other {њих}} — одлучује „свуда другде”.",
  "settings.pinUnreachable": "Никада се не користи — не досеже ниједну вашу станицу",
  "settings.pinUsedAt": "Користи се на {stations}",
  "settings.pinUsedAtAll": "{count, plural, one {Користи се на вашој станици} few {Користи се на свих # станица} other {Користи се на свих # станица}}",
  "settings.pinUsedAtSome": "Користи се на {used} од {count, plural, one {# станице} few {# станице} other {# станица}}",
  "settings.polish": "пољски",
  "settings.portuguese": "португалски",
  "settings.preferencesSection": "Поставке",
  "settings.preferredModels": "Жељени модели",
  "settings.preferredModelsAll": "Једна листа, све станице",
  "settings.preferredModelsOne": "Једна листа, важи свуда",
  "settings.premium": "Премијум",
  "settings.premiumActive": "Активно",
  "settings.premiumAnnualThenPrice": "Затим 9,99 €/годишње",
  "settings.premiumAnnualTrialInfo": "Започните са бесплатним пробним периодом од {days} дана",
  "settings.premiumCurrentPlan": "Тренутни план",
  "settings.premiumDescription": "Откључај погодности премијум налога",
  "settings.premiumDownloadApp": "Преузмите апликацију да бисте се претплатили:",
  "settings.premiumExpiresOn": "Обнавља се {date}",
  "settings.premiumFreePlan": "Бесплатно",
  "settings.premiumInactive": "Без претплате",
  "settings.premiumManageWebSubscription": "Управљајте претплатом, ажурирајте начин плаћања или откажите.",
  "settings.premiumPremiumPlan": "Премиум",
  "settings.premiumSubscribeAnnual": "Годишње — 9,99 €/година",
  "settings.premiumSubscribedOn": "Претплаћено преко {platform}",
  "settings.premiumSubscribeMonthly": "Месечно — 1,99 €/месец",
  "settings.premiumSubscribeOnWeb": "Претплатите се сада да откључате све премиум функције.",
  "settings.premiumSubscriptionSuccess": "Ваша претплата је активирана! Уживајте у свим премиум функцијама.",
  "settings.premiumSubscriptionSuccessTitle": "Добродошли у Premium!",
  "settings.premiumWebappNotice": "Претплате се могу купити само путем мобилне апликације SmartMixin на iOS-у или Android-у.",
  "settings.privacyPolicy": "Политика приватности",
  "settings.profile": "Профил",
  "settings.removePreferredModel": "Уклони {model} из жељених модела",
  "settings.resetForecastPreference": "Врати подразумевано",
  "settings.resetForecastPreferenceHint": "Брише ваше жељене моделе и враћа подразумевано подешавање SmartMixin-а.",
  "settings.russian": "руски",
  "settings.seePremium": "Погледај Premium",
  "settings.serbian": "српски",
  "settings.servedNowMany": "Управо сада: GFS {count, plural, one {на вашој станици} few {на свих # станица} other {на свих # станица}}.",
  "settings.servedNowNone": "Управо сада: GFS свуда.",
  "settings.settings": "Подешавања",
  "settings.signedInAs": "Пријављени као",
  "settings.slovak": "словачки",
  "settings.smallDecimals": "Мали децимали",
  "settings.smallDecimalsDescription": "Приказуј децималне цифре у мањој величини",
  "settings.socialConnectionsIntro": "Повежите своје друштвене налоге за брзу пријаву. Можете повезивати или одспајати налоге у било ком тренутку.",
  "settings.spanish": "шпански",
  "settings.statusBarWidget": "Виџет статусне траке",
  "settings.statusBarWidgetDescription": "Увек видљиви временски подаци",
  "settings.subscriptionSection": "Претплата",
  "settings.supportSection": "Подршка",
  "settings.swedish": "шведски",
  "settings.systemTheme": "Системска тема",
  "settings.termsOfService": "Услови коришћења",
  "settings.turkish": "турски",
  "settings.ukrainian": "украјински",
  "settings.units": "Јединице",
  "settings.unitsDescription": "Мерне јединице приказане унутар апликације",
  "settings.update": "Ажурирај",
  "settings.updateYourProfile": "Ажурирајте ваш профил",
  "settings.updateYourProfileDescription": "Име и подешавања приказа",
  "settings.weatherServices": "Метеоролошке услуге",
  "settings.weatherServicesConnected": "{count, plural, =0 {Нема повезаних услуга} one {# повезана услуга} few {# повезане услуге} other {# повезаних услуга}}",
  "settings.weatherServicesDescription": "Повежите Netatmo, Davis, Weatherflow и остало",
  "settings.windDirectionConvention": "Стрелица правца ветра",
  "settings.windDirectionConventionDescription": "Изаберите приказ стрелица правца ветра",
  "settings.windDirectionMeteorological": "Правац порекла",
  "settings.windDirectionMeteorologicalDescription": "Стрелица показује одакле ветар дува (метеоролошка конвенција)",
  "settings.windDirectionOceanographic": "Правац струјања",
  "settings.windDirectionOceanographicDescription": "Стрелица показује куда ветар дува (океанографска конвенција)",
  "units.absolutePressure": "Апсолутни притисак",
  "units.airDensity": "Густина ваздуха",
  "units.airGap": "Ваздушни размак",
  "units.apparentTemperature": "Привидна температура",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Просек",
  "units.avg_wind": "Просечан ветар",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Темп. црне кугле",
  "units.boilerOn": "Бојлер УКЉУЧЕН",
  "units.co2": "CO2",
  "units.conductivity": "Проводљивост",
  "units.coolingDegreeDays": "Дани расхлађивања",
  "units.dailyHeatingDuration": "Дневно трајање загревања",
  "units.dailyPrecipitation": "Дневне падавине",
  "units.dailyRain": "Дневна киша",
  "units.degreeDay": "Дневни степени",
  "units.degreeDayShort": "ДС",
  "units.depth": "Дубина",
  "units.depthSensors": "Сензори дубине",
  "units.dewPoint": "Тачка рошења",
  "units.distance": "Удаљеност",
  "units.downTrend": "Силазни тренд",
  "units.E": "И",
  "units.E_long": "Исток",
  "units.ENE": "ИСИ",
  "units.ENE_long": "исток-североисток",
  "units.ESE": "ИЈИ",
  "units.ESE_long": "исток-југоисток",
  "units.ET": "Евапотранспирација",
  "units.ETshort": "И",
  "units.feelLike": "Субјективни осећај",
  "units.feelsLike": "Субјективни осећај",
  "units.footMile": "Стопа, миља",
  "units.frostPoint": "тачка мраза",
  "units.gust": "Удар ветра",
  "units.heatIndex": "Индекс топлоте",
  "units.heatingDegreeDays": "Дневни степени загревања",
  "units.heatingPower": "Снага загревања",
  "units.humidex": "Humidex",
  "units.humidity": "Влажност",
  "units.inch": "Инчи",
  "units.inchOfMercury": "Инчи живиног стуба",
  "units.kilometerPerHour": "Километри на сат",
  "units.knot": "Чворови",
  "units.last12Hours": "Последњих 12 сати",
  "units.last24Hours": "Последња 24 сата",
  "units.last3Hours": "Последња 3 сата",
  "units.last6Hours": "Последњих 6 сати",
  "units.lastHour": "Последњи сат",
  "units.lastLightningImpact": "Последњи удар",
  "units.lastMeasure": "Последње мерење",
  "units.leafSensors": "Сензори влажности",
  "units.leafWetness": "Влажност листова",
  "units.lightningDistance": "Удаљеност",
  "units.lightningStrikeCount": "Бројач удара муње",
  "units.lightningStrikeDistance": "Удаљеност од места удара муње",
  "units.max": "Макс.",
  "units.max_gust": "Макс. удар ветра",
  "units.maxToday": "Макс. данас",
  "units.meterKilometer": "Метар, километар",
  "units.meterPerSecond": "Метри у секунди",
  "units.milePerHour": "Миље на сат",
  "units.millibar": "Милибари",
  "units.millimeter": "Милиметри",
  "units.millimeterOfMercury": "Милиметри живиног стуба",
  "units.min": "Мин.",
  "units.N": "С",
  "units.N_long": "север",
  "units.NE": "СИ",
  "units.NE_long": "североистоку",
  "units.NNE": "ССИ",
  "units.NNE_long": "север-североисток",
  "units.NNW": "ССЗ",
  "units.NNW_long": "север-северозапад",
  "units.noise": "Бука",
  "units.normalizedHeatingCoefficient": "Нормализовани коефицијент загревања",
  "units.NW": "СЗ",
  "units.NW_long": "северозапад",
  "units.O3": "Озон",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Падавине",
  "units.pressure": "Притисак",
  "units.rain": "Киша",
  "units.rainRate": "Интензитет кише",
  "units.referenceTemperature": "Референтна температура",
  "units.relativePressure": "Релативни притисак",
  "units.S": "Ј",
  "units.S_long": "југ",
  "units.SE": "ЈИ",
  "units.SE_long": "Југоисток",
  "units.setPoint": "Почетна тачка",
  "units.snow": "Снег",
  "units.snowfall": "Снегопад",
  "units.soilMoisture": "Влажност земљишта",
  "units.soilSensors": "Подни сензори",
  "units.solarEnergy": "Соларна енергија",
  "units.solarRadiation": "Осунчаност",
  "units.speed": "Брзина",
  "units.SSE": "ЈЈИ",
  "units.SSE_long": "југ-југоисток",
  "units.SSW": "ЈЈЗ",
  "units.SSW_long": "југо-југозапад",
  "units.stableTrend": "Стабилан тренд",
  "units.sum": "Збир",
  "units.SW": "ЈЗ",
  "units.SW_long": "Југозапад",
  "units.temperature": "Температура",
  "units.temperatureAndHumiditySensors": "Сензори температуре/влажности",
  "units.temperatureSensors": "Сензори температуре/влажности",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Данас",
  "units.upTrend": "Узлазни тренд",
  "units.uv": "UV",
  "units.visibility": "Видљивост",
  "units.W": "З",
  "units.W_long": "западу",
  "units.wetBulbGlobeTemperature": "Темп. влажне кугле",
  "units.wetBulbTemperature": "Темп. мокра сијалица",
  "units.wind": "Ветар",
  "units.windChill": "Осећај хладноће",
  "units.windDirection": "Смер ветра",
  "units.windRun": "ток ветра",
  "units.windRunDescription": "Путовање ветром је укупна удаљеност коју ветар пређе у одређеном временском периоду",
  "units.WNW": "ЗСЗ",
  "units.WNW_long": "запад-северозапад",
  "units.WSW": "ЗЈЗ",
  "units.WSW_long": "запад-југозапад",
  "weatherConditions.blizzard": "Мећава",
  "weatherConditions.blowingDust": "Узвитлана прашина",
  "weatherConditions.blowingSnow": "Вејавица",
  "weatherConditions.breezy": "Лаган ветар",
  "weatherConditions.clear": "Ведро",
  "weatherConditions.cloudy": "Облачно",
  "weatherConditions.drizzle": "Ромињање",
  "weatherConditions.flurries": "Слаб снег",
  "weatherConditions.foggy": "Магла",
  "weatherConditions.freezingDrizzle": "Ледено ромињање",
  "weatherConditions.freezingRain": "Ледена киша",
  "weatherConditions.frigid": "Јака хладноћа",
  "weatherConditions.hail": "Град",
  "weatherConditions.haze": "Сумаглица",
  "weatherConditions.heavyRain": "Јака киша",
  "weatherConditions.heavySnow": "Јак снег",
  "weatherConditions.hot": "Врућина",
  "weatherConditions.hurricane": "Ураган",
  "weatherConditions.isolatedThunderstorms": "Изоловане грмљавине",
  "weatherConditions.mixedRainAndHail": "Киша и град",
  "weatherConditions.mostlyClear": "Претежно ведро",
  "weatherConditions.mostlyCloudy": "Претежно облачно",
  "weatherConditions.mostlySunny": "Претежно сунчано",
  "weatherConditions.notAvailable": "Временски услови нису доступни",
  "weatherConditions.partlyCloudy": "Делимично облачно",
  "weatherConditions.rain": "Киша",
  "weatherConditions.rainSleet": "Киша и ледене куглице",
  "weatherConditions.rainSnow": "Киша и снег",
  "weatherConditions.scatteredShowers": "Местимични пљускови",
  "weatherConditions.scatteredSnowShowers": "Местимични снежни пљускови",
  "weatherConditions.scatteredThunderstorms": "Местимичне грмљавине",
  "weatherConditions.showers": "Пљускови",
  "weatherConditions.sleet": "Ледене куглице",
  "weatherConditions.smoke": "Дим",
  "weatherConditions.snow": "Снег",
  "weatherConditions.snowShowers": "Снежни пљускови",
  "weatherConditions.strongStorms": "Јаке грмљавине",
  "weatherConditions.sunny": "Сунчано",
  "weatherConditions.thunderstorms": "Грмљавине",
  "weatherConditions.tornado": "Торнадо",
  "weatherConditions.tropicalStorm": "Тропска олуја",
  "weatherConditions.windy": "Ветровито",
  "weatherConditions.wintryMix": "Мешовите зимске падавине"
}
